/* eslint no-shadow: ["error", { "allow": ["state"] }] */
import Swal from 'sweetalert2';
import { api } from '../../domainConfig';
import axiosInstance from '../axiosInstance';

const domain = api.stockManagementDomain;
const domain2 = api.clientMasterDataDomain;
const domain3 = api.masterDataDomain;
const domain4 = api.userManagementDomain
const domain5 = api.inventoryMenagement


const state = {
  searchInNewOrders: [],
  status: false,
  resetStatus: false,
  orders: [],
  ordersPDF: [],
  filteredOrdersByON: [],
  filteredOrdersByCN: [],
  articleOders: [],
  articleOdersMaterials: [],
  createdOrders: [],
  minimalOrdersDetails: [],
  createdOrdersPDF: [],
  trackAndTraceDetailsPDF: [],
  createdOrdersByOrderNumber: [],
  orderItemsCurrentPage: 1,
  orderItemsTotal: 0,
  materialVariantsOfOrders: [],
  descriptionOfOrders: '',
  probeDates: [],
  prices: {},
  shipmentDetailsByOrder: {},
  shipmentsDetailsByOrder: [],
  currentPage: 1,
  totalItems: 0,
  totalItemsForOrderN: 0,
  totalMinimalForOrdersDetails: 0,
  totalItemsForDetails: 0,
  currentPageForCOrders: 1,
  currentPageForMinimalOrdersDetails: 1,
  currentPageForDetails: 1,
  size: '',
  twentyPrinciples: null,
  getOrder: [],
  getEditOrderItem: [],
  getEditOrderItemMaterialVariant: [],
  // Passive Stock
  productsInStock: [],
  productsInStockPDF: [],
  productsInStockQRCode: [],
  productInStock_dashboard: [],
  articleNumberLikePassiveStock: [],
  upComingPickUpDays: [],
  productsInStockWithStates: [],
  productInStockMaterialVariants: [],
  orderTypes: [],
  yearlyDashboard: [],
  monthlyDashboard: [],
  mostSoldProducts: [],
  locationsByType: [],
  location: [],
  locationTypes: [],
  locationByPagination: [],
  locationByPaginationCurrentPage: 1,
  locationByPaginationTotalItems: 0,
  filterLocation: [],
  productInStockLocation: [],
  orderItemLocationPagination: [],
  articleNumberLike: [],
  productInStockArticleNumberLike: [],
  resetLocation: [],
  productInStockLocationPagination: [],
  orderItemLocation: [],
  track_And_Trace_By_Employee: [],
  productInStockLocationPDF: [],
  dashboardCounterItems: {},
  dashboardOrders: [],
  adminOrders: [],
  materialOrders: [],
  createdDeliveredOrder: [],
  orderItemPaymentByOrderNumber: [],
  totalPriceByMaterialId: [],
  trackProcessingEmployees: [],
  trackProcessingActivity: [],
  trackProcessingActivityItemId: [],
  trackAndTraceCounter: [],
  trackAndTraceDetails: [],
  invoiceByOrder: [],
  totalNumberItemsByDate: [],
  savedStock: 0,
  itemsSold: [],
  itemsSoldStores: [],
  itemsSoldMonth: [],
  storeSoldTracking: [],
  usersMultipleRoles: [],
  newNominativeOrders: [],
  newNominativeOrdersCP: [],
  newNominativeOrdersTotalItems: [],
  sellingReportGrouped: [],
  sellingReportGroupedCurrent: [],
  sellingReportGroupedTotalItems: [],
  orderMaterialsMoving: [],
  allOrdersMoving: [],
  locationsMoving: [],
  isAddedTransit: null,
  itemsMovementCount: null,
  filterItemsMovement: [],
  currentPageFilter: 1,
  totalItemsFilter: 1,
  filterOrderMovement: [],
  currentPageOrder: 1,
  totalItemsOrder: 1,
  orderMaterials: [],
  shipFromStoreToManufacturyDetails: [],
  shipFrmManufacturyToStoreDetails: [],
  filterOrderArticlesState: [],
  totalItemsArticlesState: 1,
  filterProductInStockMovements: [],
  filterProductInStockOrderMovements: [],
  filterProductsMovementId: [],
  productInStockList: [],
  productsInStockMovementId: [],
  productInStockTrackTrace: [],
  productInStockTrackTraceTotalItems: [],
  productInStockTrackTraceCurrentPage: [],
  deliveredOrders: [],
  windowDetailsByWindowId: [],
  montageAppointment: [],
  appointmentMontage: [],
  newInvoiceByOrder: [],
  invoiceByOrderIdOther: [],
  reportingDelivers: [],
  reportingDeliversItems: [],
  filterDeliveryNumber: [],
  invoiceNumberFilter: [],
  trackingByOrderArticle: [],
  partiallyDeliveredOrders: [],
  totalItemsPartiallyOrders: [],
  orderItemsByOrderId: [],
  articlesInCart: [],
  totalItemsCart: 0,
  articlesInCartOrdered: [],
  totalItemsCartOrdered: 0,
  articlesInHistory: [],
  PDFArticlesInHistory: [],
  totalItemsHistory: 0,
  PDFTotalItemsHistory: 0,
  totalPagesItemsHistory: 0,
  PDFTotalPagesItemsHistory: 0,
  clickedArticleInHistory: [],
  isArticleInCart: false,
  orderDescWidth: {},
  paidAmountByOrderId: {},
  itemsByOrderId: {},
  priceForArticle: 0,
  deliveryMinimalInfosArticle: [],
  deliveryMinimalInfosArticleItems: 0,
};

const getters = {
  getTotalPagesHistory: (state) => {
    return state.totalPagesItemsHistory
  },
  getPDFTotalPagesHistory: (state) => {
    return state.PDFTotalPagesItemsHistory
  },
  getReportingDeliversSecond: (state) => {
    return state.reportingDelivers
  },
  getDeliveryMinimalInfosArticle: (state) => {
    return state.deliveryMinimalInfosArticle
  },
  getDeliveryMinimalInfosArticleItems: (state) => {
    return state.deliveryMinimalInfosArticleItems
  },
  getInvoiceNumberFilter: (state) => {
    return state.invoiceNumberFilter
  },
  getOrderDescWidth: (state) => {
    return state.orderDescWidth
  },
  getOrderItemsByOrderId: (state) => {
    return state.orderItemsByOrderId
  },
  getItemsByOrderId: (state) => {
    return state.itemsByOrderId
  },
  getArticlesInCart: (state) => {
    return state.articlesInCart
  },
  getPaidAdmountByOrder: (state) => {
    return state.paidAmountByOrderId
  },
  getTotalItemsArticleCart: (state) => {
    return state.totalItemsCart
  },
  getArticlesInCartOrdered: (state) => {
    return state.articlesInCartOrdered
  },
  getTotalItemsArticleCartOrdered: (state) => {
    return state.totalItemsCartOrdered
  },
  getArticlesInHistory: (state) => {
    return state.articlesInHistory
  },
  getPDFArticlesInHistory: (state) => {
    return state.PDFArticlesInHistory
  },
  getTotalItemsHistory: (state) => {
    return state.totalItemsHistory
  },
  getPDFTotalItemsHistory: (state) => {
    return state.PDFTotalItemsHistory
  },
  getClickedArticleInHistory: (state) => {
    return state.clickedArticleInHistory
  },
  getIsArticleOnCart: (state) => {
    return state.isArticleInCart
  },
  getFilterDeliveryNumber: (state) => {
    return state.filterDeliveryNumber
  },
  getReportingDeliversItemsSecond: (state) => {
    return state.reportingDeliversItems
  },
  getPartiallyDeliveredOrders: (state) => {
    return state.partiallyDeliveredOrders
  },
  getTotalItemsPartiallyOrders: (state) => {
    return state.totalItemsPartiallyOrders
  },
  getTrackingByOrderArticle: (state) => {
    return state.trackingByOrderArticle
  },
  getOrders: (state) => {
    state.orders.unshift();
    return state.orders;
  },
  getOrdersPDF: (state) => {
    state.orders.unshift();
    return state.ordersPDF;
  },
  getStoreManuDetails: (state) => {
    return state.shipFromStoreToManufacturyDetails
  },
  getProductsInStockMovements: (state) => {
    return state.filterProductInStockMovements
  },
  getProductsInStockOrderMovements: (state) => {
    return state.filterProductInStockOrderMovements
  },
  getCreatedDeliveredOrders: (state) => {
    return state.createdDeliveredOrder
  },
  getMontageAppointment: (state) => {
    return state.montageAppointment
  },
  getAppointmentsWithoutId: (state) => {
    return state.appointmentMontage
  },
  getProductsInStockMovementId: (state) => {
    return state.filterProductsMovementId
  },
  getProductsInStockByMovementId: (state) => {
    return state.productsInStockMovementId
  },
  getManuStoreDetails: (state) => {
    return state.shipFrmManufacturyToStoreDetails
  },
  getIsAddedToTransit: (state) => {
    return state.isAddedTransit
  },
  getOrderMaterials: (state) => {
    return state.orderMaterials
  },
  getFilterItemsArticlesState: (state) => {
    return state.filterOrderArticlesState
  },
  getTotalItemsArticlesState: (state) => {
    return state.totalItemsArticlesState
  },
  getFilterItemsMovement: (state) => {
    return state.filterItemsMovement
  },
  getCurrentPageFilter: (state) => {
    return state.currentPageFilter
  },
  getTotalItemsFilter: (state) => {
    return state.totalItemsFilter
  },
  getOrderItemsMovement: (state) => {
    return state.filterOrderMovement
  },
  getCurrentPageOrder: (state) => {
    return state.currentPageOrder
  },
  getTotalItemsOrder: (state) => {
    return state.totalItemsOrder
  },
  getItemsMovementCount: (state) => {
    return state.itemsMovementCount
  },
  getTrackAndTraceCounter: (state) => {
    return state.trackAndTraceCounter
  },
  getSavedStock: (state) => {
    return state.savedStock
  },
  getTrackAndTraceDetails: (state) => {
    return state.trackAndTraceDetails
  },
  getShipmentDetailsByOrder: (state) => {
    return state.shipmentDetailsByOrder
  },
  getShipmentsDetailsByOrder: (state) => {
    return state.shipmentsDetailsByOrder
  },
  getInvoiceByOrderNumber: (state) => {
    return state.invoiceByOrder
  },
  getOrderItemPaymentByOrderNumber: (state) => {
    return state.orderItemPaymentByOrderNumber;
  },
  getProcessingEmployees: (state) => {
    return state.trackProcessingEmployees
  },
  getProcessingActivity: (state) => {
    return state.trackProcessingActivity
  },
  getTrackAndTraceDetailsPDF: (state) => {
    return state.trackAndTraceDetailsPDF
  },
  getProcessingActivityItemId: (state) => {
    return state.trackProcessingActivityItemId
  },
  getTotalPriceByMaterialId: (state) => {
    return state.totalPriceByMaterialId;
  },
  getAdminOrders: (state) => {
    return state.adminOrders;
  },
  getMaterialOrders: (state) => {
    return state.materialOrders;
  },
  getResetLocation: (state) => {
    return state.resetLocation;
  },
  getFilterLocation: (state) => {
    return state.filterLocation;
  },
  getLocationByPagination: (state) => {
    return state.locationByPagination;
  },
  getLocationByPaginationCurrentPage: (state) => {
    return state.locationByPaginationCurrentPage;
  },
  getLocationByPaginationTotalItems: (state) => {
    return state.locationByPaginationTotalItems;
  },
  getLocationTypes: (state) => {
    return state.locationTypes;
  },
  getLocation: (state) => {
    return state.location;
  },
  getEditOrder: (state) => {
    return state.getEditOrderItem;
  },
  getProbeDates: (state) => {
    return state.probeDates;
  },
  getPrices: (state) => {
    return state.prices;
  },
  getOrderItemLocatioon: () => {
    return state.orderItemLocation
  },
  getEditOrderItemMaterialVariant: (state) => {
    return state.getEditOrderItemMaterialVariant
  },
  getSearchInNewOrders: (state) => {
    return state.searchInNewOrders;
  },
  getOrderTypes: (state) => {
    return state.orderTypes;
  },

  getResetStatus: (state) => {
    return state.resetStatus;
  },
  getOrder: (state) => {
    return state.getOrder
  },
  getFilteredOrdersbyON: (state) => {
    return state.filteredOrdersByON;
  },
  getFilteredOrdersbyCN: (state) => {
    return state.filteredOrdersByCN;
  },
  getArticleOrdersMaterials: (state) => {
    return state.articleOdersMaterials;
  },
  getArticleOrders: (state) => {
    return state.articleOders;
  },
  getMaterialVariantsOfOrder: (state) => {
    return state.materialVariantsOfOrders;
  },
  getDescriptionOfOrder: (state) => {
    return state.descriptionOfOrders;
  },
  getCurrentPageForOrders: (state) => {
    return state.currentPage;
  },
  getCurrentPageForCreatedOrders: (state) => {
    return state.currentPageForCOrders;
  },
  getCurrentPageForCDetails: (state) => {
    return state.currentPageForDetails;
  },
  getCurrentPageForOrderItems: (state) => {
    return state.orderItemsCurrentPage;
  },
  getTotalItemsForOrderItems: (state) => {
    return state.orderItemsTotal;
  },
  getTotalItemsForOrders: (state) => {
    return state.totalItems;
  },
  getTotalItemsForOrderN: (state) => {
    return state.totalItemsForOrderN;
  },
  getTotalMinimalItemsForOrderDetails: (state) => {
    return state.totalMinimalForOrdersDetails;
  },
  getTotalItemsForDetails: (state) => {
    return state.totalItemsForDetails;
  },
  getCreatedOrders: (state) => {
    return state.createdOrders;
  },
  getMinimaldOrderDetailss: (state) => {
    return state.minimalOrdersDetails;
  },
  getCreateOrdersPDF: (state) => {
    return state.createdOrdersPDF;
  },
  getCreatedOrdersByOrderNumber: (state) => {
    return state.createdOrdersByOrderNumber;
  },
  getTwentyPrinciples: () => {
    return state.twentyPrinciples;
  },
  getOrderItemSize: () => {
    return state.size;
  },
  getYearlyDashboard: () => {
    return state.yearlyDashboard;
  },
  getMonthlyDashboard: () => {
    return state.monthlyDashboard
  },
  // Passive Stock
  getProductsInStock: () => {
    return state.productsInStock
  },
  getProductsInStockQRCode: () => {
    return state.productsInStockQRCode
  },
  getProductsInStockPDF: () => {
    return state.productsInStockPDF
  },
  getProductInStockDashboard: () => {
    return state.productInStock_dashboard
  },
  getArticleNameLike: () => {
    return state.articleNumberLikePassiveStock
  },
  getUpComingPickUpDates: () => {
    return state.upComingPickUpDays
  },
  getProductInStockWithStates: () => {
    return state.productsInStockWithStates
  },
  getProductInStockMaterialVariants: () => {
    return state.productInStockMaterialVariants
  },
  getMostSoldProducts: () => {
    return state.mostSoldProducts
  },
  getLocationsByType: () => {
    return state.locationsByType
  },
  getOrderItemLocation: () => {
    return state.orderItemLocationPagination
  },
  getArticleNumberLike: () => {
    return state.articleNumberLike
  },
  getProductInStockLocationPagination: () => {
    return state.productInStockLocationPagination
  },
  getProductInStockArticleNumberLike: () => {
    return state.productInStockArticleNumberLike
  },
  getTrackAndTraceByEmployee: () => {
    return state.track_And_Trace_By_Employee
  },
  getProductInStockLocationPDF: (state) => {
    return state.productInStockLocationPDF
  },
  getdashboardCounterItems: (state) => {
    return state.dashboardCounterItems
  },
  getDashboardOrders: (state) => {
    return state.dashboardOrders
  },
  getTotalNumberItemsByDate: (state) => {
    return state.totalNumberItemsByDate
  },
  getItemsSoldByUser: (state) => {
    return state.itemsSold
  },
  getSalesGroupedByDate: (state) => {
    return state.itemsSoldStores
  },
  getSalesGroupedByMonth: (state) => {
    return state.itemsSoldMonth
  },
  getStoreSoldTracking: (state) => {
    return state.storeSoldTracking
  },
  getUsersMultipleRoles: (state) => {
    return state.usersMultipleRoles
  },
  getNewNominativeOrders: (state) => {
    return state.newNominativeOrders
  },
  getNewNominativeOrdersCurrent: (state) => {
    return state.newNominativeOrdersCP
  },
  getNewNominativeOrdersTotalItems: (state) => {
    return state.newNominativeOrdersTotalItems
  },
  getSellingReportGrouped: (state) => {
    return state.sellingReportGrouped
  },
  getSellingReportGroupedCurrent: (state) => {
    return state.sellingReportGroupedCurrent
  },
  getSellingReportGroupedTotalItems: (state) => {
    return state.sellingReportGroupedTotalItems
  },
  getOrderMaterialsMoving: (state) => {
    return state.orderMaterialsMoving
  },
  getAllOrdersMoving: (state) => {
    return state.allOrdersMoving
  },
  getLocationsMoving: (state) => {
    return state.locationsMoving
  },
  getProductInStockList: (state) => {
    return state.productInStockList
  },
  getProductInStockTrackTrace: (state) => {
    return state.productInStockTrackTrace
  },
  getProductInStockTrackTraceTotalItems: (state) => {
    return state.productInStockTrackTraceTotalItems
  },
  getProductInStockTrackTraceCurrentPage: (state) => {
    return state.productInStockTrackTraceCurrentPage
  },
  getDeliveredOrders: (state) => {
    return state.deliveredOrders
  },
  getWindowDetails: (state) => {
    return state.windowDetailsByWindowId
  },
  getNewInvoiceByOrderNumber: (state) => {
    return state.newInvoiceByOrder
  },
  getNewInvoiceByOrderIdOther: (state) => {
    return state.invoiceByOrderIdOther
  },
  getPriceForArticle: (state) => {
    return state.priceForArticle;
  },
};

const mutations = {
  SET_WINDOW_DETAILS(state, payload) {
    state.windowDetailsByWindowId = payload;
  },
  SET_REPORTIN_DELIVER(state, latest) {
    state.reportingDelivers = latest
  },
  SET_INVOICE_NUMBER_FILTER(state, latest) {
    state.invoiceNumberFilter = latest
  },
  SET_DELIVERY_MINIMAL_INFOS_ARTICLE(state, latest) {
    state.deliveryMinimalInfosArticle = latest
  },
  SET_DELIVERY_MINIMAL_INFOS_ARTICLE_ITEMS(state, latest) {
    state.deliveryMinimalInfosArticleItems = latest
  },
  SET_PAID_AMOUNT_BY_ORDERID(state, latest) {
    state.paidAmountByOrderId = latest
  },
  SET_GET_ORDER_DESC(state, latest) {
    state.orderDescWidth = latest
  },
  SET_ARTICLES_IN_CART(state, latest) {
    state.articlesInCart = latest
  },
  SET_ITEMS_ARTICLES_IN_CART(state, latest) {
    state.totalItemsCart = latest
  },
  SET_ARTICLES_IN_CART_ORDERED(state, latest) {
    state.articlesInCartOrdered = latest
  },
  SET_ITEMS_ARTICLES_IN_CART_ORDERED(state, latest) {
    state.totalItemsCartOrdered = latest
  },
  SET_ARTICLES_IN_HISTORY(state, latest) {
    state.articlesInHistory = latest
  },
  SET_PDF_ARTICLES_IN_HISTORY(state, latest) {
    state.PDFArticlesInHistory = latest
  },
  SET_ITEMS_ARTICLES_IN_HISTORY(state, latest) {
    state.totalItemsHistory = latest
  },
  SET_PDF_ITEMS_ARTICLES_IN_HISTORY(state, latest) {
    state.PDFTotalItemsHistory = latest
  },
  SET_CLICKED_ARTICLE_IN_HISTORY(state, latest) {
    state.clickedArticleInHistory = latest
  },
  SET_TOTAL_PAGES_HISTORY(state, latest) {
    state.totalPagesItemsHistory = latest
  },
  SET_PDF_TOTAL_PAGES_HISTORY(state, latest) {
    state.PDFTotalPagesItemsHistory = latest
  },
  SET_IS_ARTICLE_IN_CART(state, latest) {
    state.isArticleInCart = latest
  },
  SET_ORDER_ITEMS_BY_ORDER_ID(state, latest) {
    state.orderItemsByOrderId = latest
  },
  SET_ITEMS_BY_ORDER_ID(state, latest) {
    state.itemsByOrderId = latest
  },
  SET_DELIVER_NUMBER(state, latest) {
    state.filterDeliveryNumber = latest
  },
  SET_PARTIALLY_DELIVERED_ORDERS(state, latest) {
    state.partiallyDeliveredOrders = latest
  },
  SET_TOTALITEMS_PARTIALLY_ORDERS(state, latest) {
    state.totalItemsPartiallyOrders = latest
  },
  SET_REPORTIN_DELIVER_ITEMS(state, latest) {
    state.reportingDeliversItems = latest
  },
  SET_TRACKING_BY_ORDER_ARTICLE(state, latest) {
    state.trackingByOrderArticle = latest
  },
  SET_ORDER_ITEM_PAYMENT_BY_ORDER_NUMBER(state, latest) {
    state.orderItemPaymentByOrderNumber = latest
  },
  SET_STATUS(state, payload) {
    state.status = payload;
  },
  SET_TRACK_AND_TRACE_DETAILS_PDF(state, payload) {
    state.trackAndTraceDetailsPDF = payload
  },
  SET_CREATED_DELIVERED_ORDERS(state, latest) {
    state.createdDeliveredOrder = latest
  },
  SET_MONTAGE_APPOINTMENTS(state, latest) {
    state.montageAppointment = latest
  },
  SET_MONTAGE_APPOINTMENTS_WITHOUT_ID(state, latest) {
    state.appointmentMontage = latest
  },
  SET_ADMIN_ORDERS(state, payload) {
    state.adminOrders = payload
  },
  SET_MATERIAL_ORDERS(state, payload) {
    state.materialOrders = payload
  },
  SET_RESET_LOCATION(state, payload) {
    state.resetLocation = payload;
  },
  SET_FILTER_LOCATION(state, payload) {
    state.filterLocation = payload;
  },
  SET_TRACK_AND_TRACE_COUNTER(state, payload) {
    state.trackAndTraceCounter = payload
  },
  SET_INVOICE_BY_ORDER(state, latest) {
    state.invoiceByOrder = latest
  },
  SET_TRACK_AND_TRACE_DETAILS(state, payload) {
    state.trackAndTraceDetails = payload
  },
  SET_LOCATION_BY_PAGINATION(state, payload) {
    state.locationByPagination = payload;
  },
  SET_LOCATION_BY_PAGINATION_CURRENT_PAGE(state, payload) {
    state.locationByPaginationCurrentPage = payload;
  },
  SET_LOCATION_BY_PAGINATION_TOTAL_ITEMS(state, payload) {
    state.locationByPaginationTotalItems = payload;
  },
  SET_LOCATIONTYPES(state, payload) {
    state.locationTypes = payload;
  },
  SET_RESET_STATUS(state, payload) {
    state.resetStatus = payload;
  },
  SET_TRACKING_EMPLOYEE(state, payload) {
    state.trackProcessingEmployees = payload
  },
  SET_TRACKING_ACTIVITY(state, payload) {
    state.trackProcessingActivity = payload
  },
  SET_TRACKING_ACTIVITY_ITEM_ID(state, payload) {
    state.trackProcessingActivityItemId = payload
  },
  SET_LOCATION(state, latest) {
    state.location = latest;
  },
  SET_CURRENTPAGE(state, payload) {
    state.currentPage = payload;
  },
  SET_ORDER(state, payload) {
    state.getOrder = payload
  },
  SET_CURRENTPAGE_FOR_CREATED_ORDERS(state, payload) {
    state.currentPageForCOrders = payload;
  },
  SET_CURRENTPAGE_FOR_MINIMAL_ORDERS_DETAILS(state, payload) {
    state.currentPageForMinimalOrdersDetails = payload;
  },
  SET_CURRENTPAGE_FOR_DETAILS(state, payload) {
    state.currentPageForDetails = payload;
  },

  SET_ORDERS(state, latest) {
    state.orders = latest;
  },
  SET_ORDERS_PDF(state, latest) {
    state.ordersPDF = latest;
  },
  SET_FILTERED_ORDERS_BY_ON(state, latest) {
    state.filteredOrdersByON = latest;
  },
  SET_TOTAL_PRICE_BY_MATERIAL_ID(state, latest) {
    state.totalPriceByMaterialId = latest
  },
  SET_FILTERED_ORDERS_BY_CN(state, latest) {
    state.filteredOrdersByCN = latest;
  },
  SET_ARTICLE_ORDERS(state, latest) {
    state.articleOders = latest;
  },
  SET_ARTICLE_ORDERS_MATERIALS(state, latest) {
    state.articleOdersMaterials = latest;
  },
  SET_TOTALITEMS_ORDERS(state, latest) {
    state.totalItems = latest;
  },
  SET_TOTALITEMS_FOR_ORDERN(state, latest) {
    state.totalItemsForOrderN = latest;
  },
  SET_TOTALITEMS_FOR_MINIMAL_ORDERS_DETAILS(state, latest) {
    state.totalMinimalForOrdersDetails = latest;
  },
  SET_TOTALITEMS_FOR_DETAILS(state, latest) {
    state.totalItemsForDetails = latest;
  },
  SET_ORDERITEMS_CURRENT_PAGE(state, latest) {
    state.orderItemsCurrentPage = latest;
  },
  SET_TOTALITEMS_FOR_ORDERT(state, latest) {
    state.orderItemsTotal = latest;
  },
  SET_CREATED_ORDERS(state, latest) {
    state.createdOrders = latest;
  },
  SET_MINIMAL_ORDERS_DETAILS(state, latest) {
    state.minimalOrdersDetails = latest;
  },
  SET_CREATED_ORDERS_PDF(state, latest) {
    state.createdOrdersPDF = latest;
  },
  SET_CREATED_ORDERS_BY_ORDER_NUMBER(state, latest) {
    state.createdOrdersByOrderNumber = latest;
  },
  SET_SEARCH_NEW_ORDERS(state, latest) {
    state.searchInNewOrders = latest;
  },
  SET_MATERIAL_VARIANTS_OF_ORDER(state, latest) {
    state.materialVariantsOfOrders = latest;
  },
  SET_DESCRIPTION(state, latest) {
    state.descriptionOfOrders = latest;
  },
  SET_PROBEDATES(state, latest) {
    state.probeDates = latest;
  },
  SET_PRICES(state, latest) {
    state.prices = latest;
  },
  SET_ORDER_ITEM_LOCATIOON(state, latest) {
    state.orderItemLocation = latest;
  },
  SET_ORDER_ITEM_SIZE(state, latest) {
    state.size = latest;
  },
  SET_TWENTY_PRINCIPLES(state, latest) {
    state.twentyPrinciples = latest;
  },
  SET_PRODUCTS_IN_STOCK(state, latest) {
    state.productsInStock = latest
  },
  SET_PRODUCTS_IN_STOCK_QRCODE(state, latest) {
    state.productsInStockQRCode = latest
  },
  SET_PRODUCTS_IN_STOCK_PDF(state, latest) {
    state.productsInStockPDF = latest
  },
  E(state, latest) {
    state.articleNumberLikePassiveStock = latest
  },
  SET_UP_COMING_PICKUP_DATES(state, latest) {
    state.upComingPickUpDays = latest
  },
  SET_PRODUCT_IN_STOCK_WITH_STATES(state, latest) {
    state.productsInStockWithStates = latest
  },
  SET_PRODUCT_IN_STOCK_MATERIALVARIANTS(state, latest) {
    state.productInStockMaterialVariants = latest
  },
  SET_ORDER_TYPES(state, latest) {
    state.orderTypes = latest;
  },
  SET_PRODUCT_IN_STOCK_DASHBOARD(state, latest) {
    state.productInStock_dashboard = latest
  },
  SET_GET_EDIT_ORDER_ITEM(state, latest) {
    state.getEditOrderItem = latest
  },
  SET_GET_EDIT_ORDER_ITEM_MATERIAL_VARIANT(state, latest) {
    state.getEditOrderItemMaterialVariant = latest
  },
  SET_YEARLY_DASHBOARD(state, latest) {
    state.yearlyDashboard = latest
  },
  SET_MONTHLY_DASHBOARD(state, latest) {
    state.monthlyDashboard = latest
  },
  SET_MOST_SOLD_PRODUCTS(state, latest) {
    state.mostSoldProducts = latest
  },
  SET_SAVED_STOCK_VALUE(state, latest) {
    state.savedStock = latest
  },
  SET_LOCATION_BY_TYPE(state, latest) {
    state.locationsByType = latest
  },
  SET_ORDER_ITEM_LOCATION(state, latest) {
    state.orderItemLocationPagination = latest
  },
  SET_ARTICLE_NUMBER_LIKEE(state, latest) {
    state.articleNumberLike = latest
  },
  SET_PRODUCT_IN_STOCK_LOCATION_PAGINATION(state, latest) {
    state.productInStockLocationPagination = latest
  },
  SET_PRODUCT_IN_STOCK_ARTICLE_NUMBER_LIKE(state, latest) {
    state.productInStockArticleNumberLike = latest
  },
  SET_TRACK_AND_TRACE_BY_EMPLOYEE(state, latest) {
    state.track_And_Trace_By_Employee = latest
  },
  SET_PRODUCT_IN_STOCK_LOCATION_PDF(state, latest) {
    state.productInStockLocationPDF = latest
  },
  SET_DASHBOARD_COUNTER_ITEMS(state, latest) {
    state.dashboardCounterItems = latest
  },
  SET_DASHBOARD_ORDERS(state, latest) {
    state.dashboardOrders = latest
  },
  SET_TOTAL_ITEMS_BY_DATE(state, latest) {
    state.totalNumberItemsByDate = latest
  },
  SET_ITEMS_SOLD_BY_USER(state, latest) {
    state.itemsSold = latest
  },
  SET_ITEMS_SOLD_BY_STORES(state, latest) {
    state.itemsSoldStores = latest
  },
  SET_ITEMS_SOLD_BY_STORES_MONTH(state, latest) {
    state.itemsSoldMonth = latest
  },
  SET_STORE_SOLD_TRACKING(state, latest) {
    state.storeSoldTracking = latest
  },
  SET_USERS_MULTIPLE_ROLES(state, latest) {
    state.usersMultipleRoles = latest
  },
  SET_NEW_NOMINATIVE_ORDERS(state, latest) {
    state.newNominativeOrders = latest
  },
  SET_NOMINATIVE_ORDERS_CURRENTPAGE(state, latest) {
    state.newNominativeOrdersCP = latest
  },
  SET_NOMINATIVE_ORDERS_TOTALITEMS(state, latest) {
    state.newNominativeOrdersTotalItems = latest
  },
  SET_SELLING_REPORT_GROUPED(state, latest) {
    state.sellingReportGrouped = latest
  },
  SET_SELLING_REPORT_GROUPED_CURRENT(state, latest) {
    state.sellingReportGroupedCurrent = latest
  },
  SET_SELLING_REPORT_GROUPED_TOTALITEMS(state, latest) {
    state.sellingReportGroupedTotalItems = latest
  },
  SET_ORDER_MATERIAL_MOVING(state, latest) {
    state.orderMaterialsMoving = latest
  },
  SET_ALL_ORDER_MOVING(state, latest) {
    state.allOrdersMoving = latest
  },
  SET_LOCATIONS_MOVING(state, latest) {
    state.locationsMoving = latest
  },
  SET_IS_ADDED_TRANSIT(state, latest) {
    state.isAddedTransit = latest
  },
  SET_ITEMS_MOVEMENT_COUNT(state, latest) {
    state.itemsMovementCount = latest
  },
  SET_FILTER_ITEMS_MOVEMENT_ARTICLES_STATE(state, latest) {
    state.filterOrderArticlesState = latest
  },
  SET_TOTAL_FILTER_ITEMS_MOVEMENT_ARTICLES_STATE(state, latest) {
    state.totalItemsArticlesState = latest
  },
  SET_FILTER_ITEMS_MOVEMENT(state, latest) {
    state.filterItemsMovement = latest
  },
  SET_PAGE_FILTER_ITEMS_MOVEMENT(state, latest) {
    state.currentPageFilter = latest
  },
  SET_TOTAL_FILTER_ITEMS_MOVEMENT(state, latest) {
    state.totalItemsFilter = latest
  },
  SET_ORDER_ITEMS_MOVEMENT(state, latest) {
    state.filterOrderMovement = latest
  },
  SET_PAGE_ORDER_ITEMS_MOVEMENT(state, latest) {
    state.currentPageOrder = latest
  },
  SET_TOTAL_ORDER_ITEMS_MOVEMENT(state, latest) {
    state.totalItemsOrder = latest
  },
  SET_ORDER_MATERIALS(state, latest) {
    state.orderMaterials = latest
  },
  SET_SHOP_MANU(state, latest) {
    state.shipFromStoreToManufacturyDetails = latest
  },
  SET_MANU_STORE(state, latest) {
    state.shipFrmManufacturyToStoreDetails = latest
  },
  SET_FILTERED_PRODUCTS_MOVEMENTS(state, latest) {
    state.filterProductInStockMovements = latest
  },
  SET_FILTERED_PRODUCTS_ORDER_MOVEMENTS(state, latest) {
    state.filterProductInStockOrderMovements = latest
  },
  SET_SHIPMENT_BY_ORDER(state, latest) {
    state.shipmentDetailsByOrder = latest
  },
  SET_SHIPMENTS_BY_ORDER(state, latest) {
    state.shipmentsDetailsByOrder = latest
  },
  SET_FILTERED_PRODUCTS_MOVEMENT_ID(state, latest) {
    state.filterProductsMovementId = latest
  },
  SET_FILTERED_PRODUCTS_BY_MOVEMENT_ID(state, latest) {
    state.productsInStockMovementId = latest
  },
  SET_PRODUCT_INSTOCK_LIST(state, latest) {
    state.productInStockList = latest
  },
  SET_PRODUCT_IN_STOCK_TRACK_TRACE(state, latest) {
    state.productInStockTrackTrace = latest
  },
  SET_PRODUCT_IN_STOCK_TRACK_TRACE_TOTAL_ITEMS(state, latest) {
    state.productInStockTrackTraceTotalItems = latest
  },
  SET_PRODUCT_IN_STOCK_TRACK_TRACE_CURRENT_PAGE(state, latest) {
    state.productInStockTrackTraceCurrentPage = latest
  },
  SET_DELIVERED_ORDERS(state, latest) {
    state.deliveredOrders = latest
  },
  SET_INVOICE_BY_ORDER_ID(state, latest) {
    state.newInvoiceByOrder = latest
  },
  SET_INVOICE_BY_ORDER_ID_OTHER(state, latest) {
    state.invoiceByOrderIdOther = latest
  },
  SET_PRICE_FOR_ARTICLE(state, latest) {
    state.priceForArticle = latest
  },
};

const actions = {
  async loadInvoiceByOrderItem({ commit }, {
    orderId,
  }) {
    const requestId = 'loadInvoiceByOrderItem'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/invoice_items_by_orderId`, {
        params: {
          orderId,
        },
      });
      commit('SET_INVOICE_BY_ORDER_ID', response.data);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async loadInvoiceByOrderIdOther({ commit }, {
    orderId,
  }) {
    const requestId = 'loadInvoiceByOrderIdOther'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/production_items_by_orderId`, {
        params: {
          orderId,
        },
      });
      commit('SET_INVOICE_BY_ORDER_ID_OTHER', response.data);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async loadDeliveryMinimalInfos({ commit }, {
    deliveryManagementId, pageNumber, pageSize,
  }) {
    const requestId = 'loadDeliveryMinimalInfos'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain5}/delivery_minimal_infos_for_articles`, {
        params: {
          deliveryManagementId,
          pageNumber,
          pageSize,
        },
      });
      commit('SET_DELIVERY_MINIMAL_INFOS_ARTICLE', response.data.items);
      commit('SET_DELIVERY_MINIMAL_INFOS_ARTICLE_ITEMS', response.data.totalItems);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async loadOrderItemsByOrderId({ commit }, {
    orderId,
  }) {
    const requestId = 'loadOrderItemsByOrderId'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/order_items_by_orderId`, {
        params: {
          orderId,
        },
      });
      commit('SET_ORDER_ITEMS_BY_ORDER_ID', response.data);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async loadItemsByOrderId({ commit }, {
    orderId,
  }) {
    const requestId = 'loadItemsByOrderId'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/items_by_orderId`, {
        params: {
          orderId,
        },
      });
      commit('SET_ITEMS_BY_ORDER_ID', response.data);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async resetLoadItemsByOrderId({ commit }) {
    commit('SET_ITEMS_BY_ORDER_ID', {});
  },
  async loadOrderItemPaymentTrackByOrderNumber({ commit }, {
    orderId,
  }) {
    const requestId = 'loadOrderItemPaymentTrackByOrderNumber'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/payment_track_by_orderId`, {
        params: {
          orderId,
        },
      });
      commit('SET_ORDER_ITEM_PAYMENT_BY_ORDER_NUMBER', response.data);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async loadReportingDelivers({ commit }, {
    deliveryManagementId, startFilterCreated, endFilterCreated, invoiceNumber, supplierId, pageNumber, pageSize,
  }) {
    const requestId = 'loadReportingDelivers'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain5}/reporting_delivers`, {
        params: {
          deliveryManagementId,
          startFilterCreated,
          endFilterCreated,
          invoiceNumber,
          supplierId,
          pageNumber,
          pageSize,
        },
      });
      commit('SET_REPORTIN_DELIVER', response.data.items);
      commit('SET_REPORTIN_DELIVER_ITEMS', response.data.totalItems)
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async loadTrackingByOrderArticle({ commit }, {
    deliveryManagementId,
  }) {
    const requestId = 'loadTrackingByOrderArticle'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain5}/delivery_details_by_id`, {
        params: {
          deliveryManagementId,
        },
      });
      commit('SET_TRACKING_BY_ORDER_ARTICLE', response.data);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async trackAndTraceDetailsPDF({ commit }, {
    startDate, endDate, state, pageNumber, pageSize,
  }) {
    const requestId = 'trackAndTraceDetailsPDF'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/track_trace_details_by_Date_state`, {
        params: {
          startDate,
          endDate,
          state,
          pageNumber,
          pageSize,
        },
      });
      commit('SET_TRACK_AND_TRACE_DETAILS_PDF', response.data);
      commit('SET_CURRENTPAGE_FOR_DETAILS', response.data.currentPage)
      commit('SET_TOTALITEMS_FOR_DETAILS', response.data.totalItems)
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async shipmentByOrders({ commit }, {
    orderId,
  }) {
    const requestId = 'shipmentByOrders'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/shipment_by_orderId`, {
        params: {
          orderId,
        },
      });
      commit('SET_SHIPMENT_BY_ORDER', response.data);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async shipmentsByOrders({ commit }, {
    orderId,
  }) {
    const requestId = 'shipmentsByOrders'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/shipments_by_orderId`, {
        params: {
          orderId,
        },
      });
      commit('SET_SHIPMENTS_BY_ORDER', response.data);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async addItemsArticleCart({ commit }, { object, storeId, successCallback }) {
    const requestId = 'addItemsArticleCart'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.post(`${domain5}/add_items_to_cart`, object, {
        params: {
          storeId,
        },
      });
      commit('SET_STATUS', true);
      Swal.fire({
        icon: 'success',
        title: 'Successfully',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2500,
      });
      successCallback();
    } catch (error) {
      if (error.response.status === 400) {
        Swal.fire({
          icon: 'error',
          title: 'Invalid data. Please try again.',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
      } else if (error.response.status === 500) {
        Swal.fire({
          icon: 'error',
          title: error.response.data.Message,
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
        commit('SET_LOADING_STATE', { requestId, isLoading: false });
      }
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async procesOrderPayment({ commit }, { object, successCallback }) {
    const requestId = 'procesOrderPayment'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.post(`${domain}/process_order_payment`, object);
      commit('SET_STATUS', true);
      Swal.fire({
        icon: 'success',
        title: 'Successfully',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2500,
      });
      successCallback();
    } catch (error) {
      if (error.response.status === 400) {
        Swal.fire({
          icon: 'error',
          title: 'Invalid data. Please try again.',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
      } else if (error.response.status === 500) {
        Swal.fire({
          icon: 'error',
          title: error.response.data.Message,
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
        commit('SET_LOADING_STATE', { requestId, isLoading: false });
      }
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async sellPartialOrders({ commit }, { object, successCallback }) {
    const requestId = 'sellPartialOrders'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.post(`${domain}/sell_partial_orders`, object);
      commit('SET_STATUS', true);
      Swal.fire({
        icon: 'success',
        title: 'Successfully',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2500,
      });
      successCallback();
    } catch (error) {
      if (error.response.status === 400) {
        Swal.fire({
          icon: 'error',
          title: 'Invalid data. Please try again.',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
      } else if (error.response.status === 500) {
        Swal.fire({
          icon: 'error',
          title: error.response.data.Message,
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
        commit('SET_LOADING_STATE', { requestId, isLoading: false });
      }
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async addMerchandise({ commit }, { object, successCallback }) {
    const requestId = 'addMerchandise'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.post(`${domain5}/add_merchandise`, object);
      commit('SET_STATUS', true);
      Swal.fire({
        icon: 'success',
        title: 'Successfully',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2500,
      });

      if (successCallback && typeof successCallback === 'function') {
        successCallback();
      }
    } catch (error) {
      if (error.response.status === 400) {
        Swal.fire({
          icon: 'error',
          title: 'Invalid data. Please try again.',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
      } else if (error.response.status === 500) {
        Swal.fire({
          icon: 'error',
          title: error.response.data.Message,
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
        commit('SET_LOADING_STATE', { requestId, isLoading: false });
      }
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async editPaymentByTrack({ commit }, { object, successCallback }) {
    const requestId = 'editPaymentByTrack'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.post(`${domain}/edit_payment_track`, object);
      commit('SET_STATUS', true);
      Swal.fire({
        icon: 'success',
        title: 'Successfully',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2500,
      });

      if (successCallback && typeof successCallback === 'function') {
        successCallback();
      }
    } catch (error) {
      if (error.response.status === 400) {
        Swal.fire({
          icon: 'error',
          title: 'Invalid order data. Please try again.',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
      } else if (error.response.status === 500) {
        Swal.fire({
          icon: 'error',
          title: error.response.data.Message,
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
        commit('SET_LOADING_STATE', { requestId, isLoading: false });
      }
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async editShipmentPayment({ commit }, { object, successCallback }) {
    const requestId = 'editShipmentPayment'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.post(`${domain}/edit_shipmentCostDetail`, object);
      commit('SET_STATUS', true);
      Swal.fire({
        icon: 'success',
        title: 'Successfully',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2500,
      });

      if (successCallback && typeof successCallback === 'function') {
        successCallback();
      }
    } catch (error) {
      if (error.response.status === 400) {
        Swal.fire({
          icon: 'error',
          title: 'Invalid order data. Please try again.',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
      } else if (error.response.status === 500) {
        Swal.fire({
          icon: 'error',
          title: error.response.data.Message,
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
        commit('SET_LOADING_STATE', { requestId, isLoading: false });
      }
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async editShipmentOrder({ commit }, { object, successCallback }) {
    const requestId = 'editShipmentOrder'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.put(`${domain}/edit_order_shipment_price`, object);
      commit('SET_STATUS', true);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
    successCallback();
  },
  async completeDelivery({ commit }, { object, deliveryManagementId, successCallback }) {
    const requestId = 'editShipmentOrder'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.put(`${domain5}/complete_delivery`, object, {
        params: {
          deliveryManagementId,
        },
      });
      commit('SET_STATUS', true);
      successCallback();
      return response.data;
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
      throw error;
    } finally {
      commit('SET_LOADING_STATE', { requestId, isLoading: false });
    }
  },
  async editOrderItemsOrder({ commit }, { object, successCallback }) {
    const requestId = 'editOrderItemsOrder'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.put(`${domain}/edit_order_items`, object);
      commit('SET_STATUS', true);
      Swal.fire({
        icon: 'success',
        title: 'Updated order',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2500,
      });
      successCallback(response.data);
    } catch (error) {
      // Handle error response
      // Show error message using SweetAlert if needed
      if (error.response.status === 400) {
        Swal.fire({
          icon: 'error',
          title: 'Invalid data. Please try again.',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
        commit('SET_LOADING_STATE', { requestId, isLoading: false });
      } else if (error.response.status === 500) {
        Swal.fire({
          icon: 'error',
          title: error.response.data.Message,
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
      }
      commit('SET_LOADING_STATE', { requestId, isLoading: false });
      throw error;
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  // async editOrderItemsOrder({ commit }, { object, successCallback }) {
  //   const requestId = 'editOrderItemsOrder'
  //   commit('SET_LOADING_STATE', { requestId, isLoading: true });
  //   try {
  //     const response = await axiosInstance.put(`${domain}/edit_order_items`, object);
  //     commit('SET_STATUS', true);
  //     successCallback(response.data);
  //   } catch (error) {
  //     commit('SET_LOADING_STATE', { requestId, isLoading: false })
  //     throw error;
  //   }
  //   commit('SET_LOADING_STATE', { requestId, isLoading: false });
  // },
  async editOrderItemPayment({ commit }, { object, successCallback }) {
    const requestId = 'editOrderItemPayment'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.post(`${domain}/edit_order_price`, object);
      commit('SET_STATUS', true);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
    successCallback();
  },
  async loadAllOrdersDetails({ commit }, {
    orderNumber,
  }) {
    const requestId = 'loadAllOrdersDetails'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/orderItemPaymentTrackByOrderNumber`, {
        params: {
          orderNumber,
        },
      });
      commit('SET_ORDER_ITEM_PAYMENT_BY_ORDER_NUMBER', response.data);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  resetOrderItemTrack({ commit }) {
    commit('SET_ORDER_ITEM_PAYMENT_BY_ORDER_NUMBER', [])
  },
  async loadMontageAppointments({ commit }, {
    start, end, storeId,
  }) {
    const requestId = 'loadMontageAppointments'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/appointments`, {
        params: {
          start,
          end,
          storeId,
        },
      });
      commit('SET_MONTAGE_APPOINTMENTS', response.data);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async loadMontageAppointmentsWithoutId({ commit }) {
    const requestId = 'loadMontageAppointmentsWithoutId'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/order_in_ready_to_deliver_state`);
      commit('SET_MONTAGE_APPOINTMENTS_WITHOUT_ID', response.data);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async loadWindowDetails({ commit }, {
    windowId, orderId,
  }) {
    const requestId = 'loadWindowDetails'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/window_details_by_windowId`, {
        params: {
          windowId,
          orderId,
        },
      });
      commit('SET_WINDOW_DETAILS', response.data);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async loadProductInStockList({ commit }, {
    state, articleNumber, pageNumber, pageSize,
  }) {
    const requestId = 'loadProductInStockList'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/productInStock_and_location`, {
        params: {
          state,
          articleNumber,
          pageNumber,
          pageSize,
        },
      });
      commit('SET_PRODUCT_INSTOCK_LIST', { data: response.data.items, items: response.data.totalItems });
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async loadDeliveredOrders({ commit }, {
    clientId, orderNumber, year, pageNumber, pageSize,
  }) {
    const requestId = 'loadDeliveredOrders'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/delivered_orders`, {
        params: {
          clientId,
          orderNumber,
          year,
          pageNumber,
          pageSize,
        },
      });
      console.log(response)

      commit('SET_DELIVERED_ORDERS', response.data.items);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async filterProductsStockMovements({ commit }, {
    state, senderLocationId, pageNumber, pageSize,
  }) {
    const requestId = 'filterProductsStockMovements'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/filter_productInstocks_movement`, {
        params: {
          state,
          senderLocationId,
          pageNumber,
          pageSize,
        },
      });
      commit('SET_FILTERED_PRODUCTS_MOVEMENTS', { data: response.data.items, items: response.data.totalItems });
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async filterProductsStockOrderMovements({ commit }, {
    shipType, deliverDate, receiverLocationId, pageNumber, pageSize, movementState,
  }) {
    const requestId = 'filterProductsStockOrderMovements'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/filter_productInStock_order_movements`, {
        params: {
          shipType,
          deliverDate,
          receiverLocationId,
          pageNumber,
          pageSize,
          movementState,
        },
      });
      commit('SET_FILTERED_PRODUCTS_ORDER_MOVEMENTS', { data: response.data.items, items: response.data.totalItems });
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async filterProductsByMovementId({ commit }, {
    orderMovementId,
  }) {
    const requestId = 'filterProductsByMovementId'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/filter_productInstocks_by_movementId`, {
        params: {
          orderMovementId,
        },
      });
      commit('SET_FILTERED_PRODUCTS_MOVEMENT_ID', response.data);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async filterProductsStockByMovementId({ commit }, {
    orderMovementId,
  }) {
    const requestId = 'filterProductsStockByMovementId'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/product_in_stock_events_by_movementId`, {
        params: {
          orderMovementId,
        },
      });
      commit('SET_FILTERED_PRODUCTS_BY_MOVEMENT_ID', response.data);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async loadDetailsShopManu({ commit }, {
    shipToManufactoryMovementId,
  }) {
    const requestId = 'loadDetailsShopManu'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/ship_from_store_to_manufactory_details`, {
        params: {
          shipToManufactoryMovementId,
        },
      });
      commit('SET_SHOP_MANU', response.data);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async loadDetailsManuShop({ commit }, {
    shipToStoreMovementId,
  }) {
    const requestId = 'loadDetailsManuShop'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/ship_from_manufactory_to_store_details`, {
        params: {
          shipToStoreMovementId,
        },
      });
      commit('SET_MANU_STORE', response.data);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async isAddedToTransit({ commit }, { orderItemId, successCallback }) {
    const requestId = 'isAddedToTransit'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/is_added_into_transit`, {
        params: {
          orderItemId,
        },
      });
      commit('SET_IS_ADDED_TRANSIT', response.data);
      successCallback(response.data)
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async itemsCount({ commit }, { state }) {
    const requestId = 'itemsCount'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/items_movement_count`, {
        params: {
          state,
        },
      });
      commit('SET_ITEMS_MOVEMENT_COUNT', response.data);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async loadCreatedOrderedDevliered({ commit }, {
    year, month,
  }) {
    const requestId = 'loadCreatedOrderedDevliered'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/created_delivered_order_items`, {
        params: {
          year,
          month,
        },
      });
      commit('SET_CREATED_DELIVERED_ORDERS', response.data);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async sellingReportGroupedByOrderNumber({ commit }, {
    salesType, startDate, endDate, pageNumber, pageSize,
  }) {
    const requestId = 'sellingReportGroupedByOrderNumber'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/sellingReporting_groupedByOrderNumber`, {
        params: {
          salesType, startDate, endDate, pageNumber, pageSize,
        },
      });
      commit('SET_SELLING_REPORT_GROUPED', response.data.items);
      commit('SET_SELLING_REPORT_GROUPED_CURRENT', response.data.currentPage)
      commit('SET_SELLING_REPORT_GROUPED_TOTALITEMS', response.data.totalItems)
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async filterItemMovement({ commit }, {
    state, pageNumber, pageSize,
  }) {
    const requestId = 'filterItemMovement'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/filter_items_movement`, {
        params: {
          state, pageNumber, pageSize,
        },
      });
      commit('SET_FILTER_ITEMS_MOVEMENT', response.data.items);
      commit('SET_PAGE_FILTER_ITEMS_MOVEMENT', response.data.totalPages)
      commit('SET_TOTAL_FILTER_ITEMS_MOVEMENT', response.data.totalItems)
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async filterItemMovementArticlesState({ commit }, {
    state, pageNumber, pageSize,
  }) {
    const requestId = 'filterItemMovementArticlesState'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/filter_orders_and_articles_by_item_state`, {
        params: {
          state, pageNumber, pageSize,
        },
      });
      commit('SET_FILTER_ITEMS_MOVEMENT_ARTICLES_STATE', response.data.items);
      commit('SET_TOTAL_FILTER_ITEMS_MOVEMENT_ARTICLES_STATE', response.data.totalItems)
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async filterOrderMovement({ commit }, {
    shipType, deliverDate, pageNumber, pageSize,
  }) {
    const requestId = 'filterOrderMovement'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/filter_order_movement`, {
        params: {
          shipType, deliverDate, pageNumber, pageSize,
        },
      });
      commit('SET_ORDER_ITEMS_MOVEMENT', response.data.items);
      commit('SET_PAGE_ORDER_ITEMS_MOVEMENT', response.data.totalPages)
      commit('SET_TOTAL_ORDER_ITEMS_MOVEMENT', response.data.totalItems)
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async createdMaterialOrders({ commit }, {
    orderNumber, clientId, pageNumber, pageSize,
  }) {
    const requestId = 'createdMaterialOrders'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/created_material_orders`, {
        params: {
          orderNumber,
          clientId,
          pageNumber,
          pageSize,
        },
      });
      commit('SET_NEW_NOMINATIVE_ORDERS', response.data.items);
      commit('SET_NOMINATIVE_ORDERS_CURRENTPAGE', response.data.currentPage)
      commit('SET_NOMINATIVE_ORDERS_TOTALITEMS', response.data.totalItems)
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async totalItemsByDate({ commit }, {
    date,
  }) {
    const requestId = 'totalItemsByDate'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/total_number_items_by_date`, {
        params: {
          date,
        },
      });
      commit('SET_TOTAL_ITEMS_BY_DATE', response.data);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async soldItemsByUser({ commit }, {
    salesUserId, startDate, endDate, pageNumber, pageSize,
  }) {
    const requestId = 'soldItemsByUser'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/items_sold_by_userId`, {
        params: {
          salesUserId, startDate, endDate, pageNumber, pageSize,
        },
      });
      commit('SET_ITEMS_SOLD_BY_USER', response.data.items);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async soldItemsByStores({ commit }, {
    storeId, startDate, endDate, pageNumber, pageSize,
  }) {
    const requestId = 'soldItemsByStores'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/sales_grouped_by_date`, {
        params: {
          storeId, startDate, endDate, pageNumber, pageSize,
        },
      });
      commit('SET_ITEMS_SOLD_BY_STORES', response.data.items);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async soldItemsByStoresMonth({ commit }, {
    year,
  }) {
    const requestId = 'soldItemsByStoresMonth'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/sales_grouped_by_month`, {
        params: {
          year,
        },
      });
      commit('SET_ITEMS_SOLD_BY_STORES_MONTH', response.data);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async resetSoldItemsByStores({ commit }) {
    commit('SET_ITEMS_SOLD_BY_STORES', []);
    commit('SET_TOTALITEMS_ORDERS', 0);
  },
  async loadStoresSoldTracking({ commit }, {
    storeId, startDate, endDate, pageNumber, pageSize,
  }) {
    const requestId = 'loadStoresSoldTracking'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/items_sold_by_stores`, {
        params: {
          storeId, startDate, endDate, pageNumber, pageSize,
        },
      });
      commit('SET_STORE_SOLD_TRACKING', response.data.items);
      commit('SET_TOTALITEMS_ORDERS', response.data.totalItems);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async addOrderItemPaymentTrack({ commit }, { object, successCallback }) {
    const requestId = 'addOrderItemPaymentTrack'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.post(`${domain}/addOrderPaymentTrack`, object);
      commit('SET_STATUS', true);
      Swal.fire({
        icon: 'success',
        title: 'Successfully',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2500,
      });

      // Call the success callback if provided
      if (successCallback && typeof successCallback === 'function') {
        successCallback();
      }
    } catch (error) {
      // Handle error response
      // Show error message using SweetAlert if needed
      if (error.response.status === 400) {
        Swal.fire({
          icon: 'error',
          title: 'Invalid order data. Please try again.',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
      } else if (error.response.status === 500) {
        Swal.fire({
          icon: 'error',
          title: error.response.data.Message,
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
        commit('SET_LOADING_STATE', { requestId, isLoading: false });
      }
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async cancelAppointments({ commit }, { object, appointmentId, successCallback }) {
    const requestId = 'cancelAppointments'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.post(`${domain}/cancel_appointment?appointmentId=${appointmentId}`, object);
      commit('SET_STATUS', true);
      Swal.fire({
        icon: 'success',
        title: 'Successfully',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2500,
      });

      // Call the success callback if provided
      if (successCallback && typeof successCallback === 'function') {
        successCallback();
      }
    } catch (error) {
      // Handle error response
      // Show error message using SweetAlert if needed
      if (error.response.status === 400) {
        Swal.fire({
          icon: 'error',
          title: 'Invalid appointment data. Please try again.',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
      } else if (error.response.status === 500) {
        Swal.fire({
          icon: 'error',
          title: error.response.data.Message,
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
        commit('SET_LOADING_STATE', { requestId, isLoading: false });
      }
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async addProductInStockMovement({ commit }, { object, successCallback }) {
    const requestId = 'addProductInStockMovement'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.post(`${domain}/add_productInStock_movement`, object);
      commit('SET_STATUS', true);
      Swal.fire({
        icon: 'success',
        title: 'Successfully added product in stock to movement',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2500,
      });

      // Call the success callback if provided
      if (successCallback && typeof successCallback === 'function') {
        successCallback();
      }
    } catch (error) {
      // Handle error response
      // Show error message using SweetAlert if needed
      if (error.response.status === 400) {
        Swal.fire({
          icon: 'error',
          title: 'Invalid order data. Please try again.',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
      } else if (error.response.status === 500) {
        Swal.fire({
          icon: 'error',
          title: error.response.data.Message,
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
        commit('SET_LOADING_STATE', { requestId, isLoading: false });
      }
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async createProductInStockMovement({ commit }, { object, successCallback }) {
    const requestId = 'createProductInStockMovement'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.post(`${domain}/create_productInStock_order_movement`, object);
      commit('SET_STATUS', true);
      Swal.fire({
        icon: 'success',
        title: 'Successfully added product in stock to movement',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2500,
      });

      // Call the success callback if provided
      if (successCallback && typeof successCallback === 'function') {
        successCallback();
      }
    } catch (error) {
      // Handle error response
      // Show error message using SweetAlert if needed
      if (error.response.status === 400) {
        Swal.fire({
          icon: 'error',
          title: 'Invalid order data. Please try again.',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
      } else if (error.response.status === 500) {
        Swal.fire({
          icon: 'error',
          title: error.response.data.Message,
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
        commit('SET_LOADING_STATE', { requestId, isLoading: false });
      }
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async orderedMaterials({ commit }, { object, successCallback }) {
    const requestId = 'orderedMaterials'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.post(`${domain}/order_materials`, object);
      commit('SET_ORDER_MATERIALS', response.data)
      commit('SET_STATUS', true);
      // Call the success callback if provided
      if (successCallback && typeof successCallback === 'function') {
        successCallback();
      }
    } catch (error) {
      // Handle error response
      // Show error message using SweetAlert if needed
      if (error.response.status === 400) {
        Swal.fire({
          icon: 'error',
          title: 'Invalid order data. Please try again.',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
      } else if (error.response.status === 500) {
        Swal.fire({
          icon: 'error',
          title: error.response.data.Message,
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
        commit('SET_LOADING_STATE', { requestId, isLoading: false });
      }
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async shipOrderToManufactory({ commit }, { object, successCallback }) {
    const requestId = 'shipOrderToManufactory'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.post(`${domain}/ship_order_to_manufactory`, object);

      commit('SET_STATUS', true);
      Swal.fire({
        icon: 'success',
        title: 'Successfully shipped order to manufactory',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2500,
      });

      // Call the success callback if provided
      if (successCallback && typeof successCallback === 'function') {
        successCallback();
      }
    } catch (error) {
      // Handle error response
      // Show error message using SweetAlert if needed
      if (error.response.status === 400) {
        Swal.fire({
          icon: 'error',
          title: 'Invalid data. Please try again.',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
      } else if (error.response.status === 500) {
        Swal.fire({
          icon: 'error',
          title: error.response.data.Message,
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
        commit('SET_LOADING_STATE', { requestId, isLoading: false });
      }
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async shipOrderToStore({ commit }, { object, newOrderItemState, successCallback }) {
    const requestId = 'shipOrderToStore'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.post(`${domain}/ship_order_from_manufactory_to_store?newOrderItemState=${newOrderItemState}`, object);
      commit('SET_STATUS', true);
      Swal.fire({
        icon: 'success',
        title: 'Successfully shipped order to store',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2500,
      });

      // Call the success callback if provided
      if (successCallback && typeof successCallback === 'function') {
        successCallback();
      }
    } catch (error) {
      // Handle error response
      // Show error message using SweetAlert if needed
      if (error.response.status === 400) {
        Swal.fire({
          icon: 'error',
          title: 'Invalid data. Please try again.',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
      } else if (error.response.status === 500) {
        Swal.fire({
          icon: 'error',
          title: error.response.data.Message,
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
        commit('SET_LOADING_STATE', { requestId, isLoading: false });
      }
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async addLineItem({ commit }, { orderItemId, successCallback }) {
    const requestId = 'addLineItem'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.post(`${domain}/add_line_item?orderItemId=${orderItemId}`);
      commit('SET_STATUS', true);
      Swal.fire({
        icon: 'success',
        title: 'Successfully added to transit',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2500,
      });
      successCallback(response.data);
    } catch (error) {
      // Handle error response
      // Show error message using SweetAlert if needed
      if (error.response.status === 400) {
        Swal.fire({
          icon: 'error',
          title: 'Invalid data. Please try again.',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
      } else if (error.response.status === 500) {
        Swal.fire({
          icon: 'error',
          title: error.response.data.Message,
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
        commit('SET_LOADING_STATE', { requestId, isLoading: false });
      }
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async sellOrderInStock({ commit }, { object, successCallback }) {
    const requestId = 'sellOrderInStock'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.post(`${domain}/createOrderInStore_from_products_in_stock`, object);
      commit('SET_STATUS', true);
      Swal.fire({
        icon: 'success',
        title: 'Successfully created order.',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2500,
      });
      successCallback(response.data);
    } catch (error) {
      // Handle error response
      // Show error message using SweetAlert if needed
      if (error.response.status === 400) {
        Swal.fire({
          icon: 'error',
          title: 'Invalid order data. Please try again.',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
      } else if (error.response.status === 500) {
        Swal.fire({
          icon: 'error',
          title: error.response.data.Message,
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
        commit('SET_LOADING_STATE', { requestId, isLoading: false });
      }
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async orderMaterialInternalMoving({ commit }, { object, successCallback }) {
    const requestId = 'orderMaterialInternalMoving'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.post(`${domain}/order_materials`, object);
      commit('SET_ORDER_MATERIAL_MOVING', response.data);
      successCallback()
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async currentStockByVariant({ commit }, variantId) {
    const requestId = 'currentStockByVariant'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.post(`${domain3}/current_stock_by_variantId?variantId=${variantId}`);
      console.log(response)
      commit('SET_SAVED_STOCK_VALUE', { variantId, stockValue: response.data });
      commit('SET_STATUS', true);
    } catch (error) {
      // Handle error response
      if (error.response.status === 400) {
        Swal.fire({
          icon: 'error',
          title: 'Invalid stock',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
      } else if (error.response.status === 500) {
        Swal.fire({
          icon: 'error',
          title: error.response.data.Message,
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
      }
    } finally {
      commit('SET_LOADING_STATE', { requestId, isLoading: false });
    }
  },
  async usersByMultipleRoles({ commit }, { object, status, successCallback }) {
    const requestId = 'usersByMultipleRoles'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.post(`${domain4}/users_by_multiple_roles?status=${status}`, object, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      commit('SET_USERS_MULTIPLE_ROLES', response.data);
      if (successCallback) successCallback();
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false });
      console.error('Error fetching users by multiple roles:', error);
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async receiveVariantsAndPurchase({ commit }, { object, successCallback }) {
    const requestId = 'receiveVariantsAndPurchase'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.post(`${domain3}/receive_variants_and_purchase_direct`, object);
      successCallback();
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false });
      console.error('Error:', error);
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async receiveArticlesAndPurchase({ commit }, { object, successCallback }) {
    const requestId = 'receiveArticlesAndPurchase'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.post(`${domain5}/new_delivery`, object);
      successCallback();
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false });
      console.error('Error:', error);
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async loadCreatedOreders({ commit }, {
    pageNumber, pageSize, orderNumber, clientId, storeId,
  }) {
    const requestId = 'loadCreatedOreders'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/new_orders`, {
        params: {
          pageNumber,
          pageSize,
          orderNumber,
          clientId,
          storeId,
        },
      });
      commit('SET_CREATED_ORDERS', response.data.items);
      commit('SET_CURRENTPAGE_FOR_CREATED_ORDERS', response.data.currentPage)
      commit('SET_TOTALITEMS_FOR_ORDERN', response.data.totalItems)
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async resetloadCreatedOreders({ commit }) {
    commit('SET_CREATED_ORDERS', []);
    commit('SET_TOTALITEMS_FOR_ORDERN', 1);
  },
  async loadMinimalOrderDetailsByState({ commit }, {
    pageNumber, pageSize, orderNumber, clientId, storeId, state,
  }) {
    const requestId = 'loadMinimalOrderDetailsByState'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/minimal_orders_details_by_state`, {
        params: {
          pageNumber,
          pageSize,
          orderNumber,
          clientId,
          storeId,
          state,
        },
      });
      commit('SET_MINIMAL_ORDERS_DETAILS', response.data);
      commit('SET_CURRENTPAGE_FOR_MINIMAL_ORDERS_DETAILS', response.data.currentPage)
      commit('SET_TOTALITEMS_FOR_MINIMAL_ORDERS_DETAILS', response.data.totalItems)
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async resetMinimalOrderDetailsByState({ commit }) {
    commit('SET_MINIMAL_ORDERS_DETAILS', []);
    commit('SET_TOTALITEMS_FOR_MINIMAL_ORDERS_DETAILS', 1);
  },
  async loadInvoiceByOrderNumber({ commit }, {
    orderNumber,
  }) {
    const requestId = 'loadInvoiceByOrderNumber'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/invoice_by_order_id`, {
        params: {
          orderNumber,
        },
      });
      commit('SET_INVOICE_BY_ORDER', response.data);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async trackAndTraceCounter({ commit }, {
    startDate, endDate, state,
  }) {
    const requestId = 'trackAndTraceCounter'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/track_trace_counter_by_Date_state`, {
        params: {
          startDate,
          endDate,
          state,
        },
      });
      commit('SET_TRACK_AND_TRACE_COUNTER', response.data);
      return response.data
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
      throw error
    }
  },
  async resetTrackAndTraceCounter({ commit }) {
    commit('SET_TRACK_AND_TRACE_COUNTER', 0);
  },
  async trackAndTraceDetails({ commit }, {
    startDate, endDate, state, pageNumber, pageSize,
  }) {
    const requestId = 'trackAndTraceDetails'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/track_trace_details_by_Date_state`, {
        params: {
          startDate,
          endDate,
          state,
          pageNumber,
          pageSize,
        },
      });
      commit('SET_TRACK_AND_TRACE_DETAILS', response.data.items);
      commit('SET_CURRENTPAGE_FOR_DETAILS', response.data.currentPage)
      commit('SET_TOTALITEMS_FOR_DETAILS', response.data.totalItems)
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async resetTrackAndTraceDetails({ commit }) {
    commit('SET_TRACK_AND_TRACE_DETAILS', []);
    commit('SET_CURRENTPAGE_FOR_DETAILS', 1)
    commit('SET_TOTALITEMS_FOR_DETAILS', 0)
  },
  async totalPriceByMaterialId({ commit }, materialId) {
    const requestId = 'totalPriceByMaterialId'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain3}/getTotalPriceByMaterialId?materialId=${materialId}`);
      commit('SET_TOTAL_PRICE_BY_MATERIAL_ID', response.data)
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async dashboardCounterItemsAndProductInStock({ commit }, year) {
    const requestId = 'dashboardCounterItemsAndProductInStock'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/dashboardCounterItemsAndProductInStock`, {
        params: {
          year,
        },
      });
      commit('SET_DASHBOARD_COUNTER_ITEMS', response.data);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async dashboardOrders({ commit }, year) {
    const requestId = 'dashboardOrders'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/dashboard_sold_item_count`, {
        params: {
          year,
        },
      });
      commit('SET_DASHBOARD_ORDERS', response.data);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async loadCreatedOredersPDF({ commit }, {
    pageNumber, pageSize, storeId, orderNumber, clientId,
  }) {
    const requestId = 'loadCreatedOredersPDF'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/new_orders`, {
        params: {
          pageNumber,
          pageSize,
          orderNumber,
          storeId,
          clientId,
        },
      });
      commit('SET_CREATED_ORDERS_PDF', response.data);
      commit('SET_CURRENTPAGE_FOR_CREATED_ORDERS', response.data.currentPage)
      commit('SET_TOTALITEMS_FOR_ORDERN', response.data.totalItems)
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async resetLocationBy({ commit }) {
    commit('SET_RESET_LOCATION', [])
  },
  async filterLocationBy({ commit }, locationName) {
    const requestId = 'filterLocationBy'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain3}/location_nameLike?locationName=${locationName}`);
      commit('SET_FILTER_LOCATION', response.data);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },

  async loadTrackAndTraceByEmployee({ commit }, {
    processingUserId, year, month, pageNumber, pageSize,
  }) {
    const requestId = 'loadTrackAndTraceByEmployee'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/processing_items_by_userId`, {
        params: {
          processingUserId,
          year,
          month,
          pageNumber,
          pageSize,
        },
      });
      commit('SET_TRACK_AND_TRACE_BY_EMPLOYEE', response.data.items)
      commit('SET_LOCATION_BY_PAGINATION_CURRENT_PAGE', response.data.currentPage)
      commit('SET_LOCATION_BY_PAGINATION_TOTAL_ITEMS', response.data.totalItems)
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async locationPagination({ commit }, {
    locationId, storeId, locationType, pageNumber, pageSize,
  }) {
    const requestId = 'locationPagination'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain5}/stock_counter_by_Locations`, {
        params: {
          locationId,
          storeId,
          locationType,
          pageNumber,
          pageSize,
        },
      });
      commit('SET_LOCATION_BY_PAGINATION', response.data)
      commit('SET_LOCATION_BY_PAGINATION_CURRENT_PAGE', response.data.currentPage)
      commit('SET_LOCATION_BY_PAGINATION_TOTAL_ITEMS', response.data.totalItems)
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async loadLocationTypes({ commit }) {
    const requestId = 'loadLocationTypes'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain3}/location_types`);
      commit('SET_LOCATIONTYPES', response.data)
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async movingLocations({ commit }) {
    const requestId = 'movingLocations'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain3}/locations`);
      commit('SET_LOCATIONS_MOVING', response.data)
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  resetLocationMoving({ commit }) {
    commit('SET_LOCATIONS_MOVING', []);
  },
  async loadCreatedOrdersByOrderNumber({ commit }, {
    id, pageNumber, pageSize, successCallback,
  }) {
    const requestId = 'loadCreatedOrdersByOrderNumber'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/createdOrderItemsByOrderNumber/${id}`, {
        params: {
          pageNumber,
          pageSize,
        },
      });
      commit('SET_CREATED_ORDERS_BY_ORDER_NUMBER', response.data.items);
      commit('SET_ORDERITEMS_CURRENT_PAGE', response.data.currentPage);
      commit('SET_TOTALITEMS_FOR_ORDERT', response.data.totalItems);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
    successCallback()
  },
  async trackProcessingEmployees({ commit }, {
    windowItemId, orderState, successCallback,
  }) {
    const requestId = 'trackProcessingEmployees'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/processing_employees_by_itemId`, {
        params: {
          windowItemId,
          orderState,
        },
      });
      commit('SET_TRACKING_EMPLOYEE', response.data);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
    successCallback()
  },
  async trackProcessingActivity({ commit }, {
    orderItemId, currentState, successCallback,
  }) {
    const requestId = 'trackProcessingActivity'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/processing_activity_by_itemId_state`, {
        params: {
          orderItemId,
          currentState,
        },
      });
      commit('SET_TRACKING_ACTIVITY', response.data);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
    successCallback()
  },
  async trackProcessingActivityItemId({ commit }, {
    orderItemId, successCallback,
  }) {
    const requestId = 'trackProcessingActivityItemId'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/processing_activity_by_itemId`, {
        params: {
          orderItemId,
        },
      });
      commit('SET_TRACKING_ACTIVITY_ITEM_ID', response.data);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
    successCallback()
  },
  async resetLoadCreatedOrdersByOrderNumber({ commit }, {
    id, pageNumber, pageSize, successCallback,
  }) {
    const requestId = 'resetLoadCreatedOrdersByOrderNumber'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    await axiosInstance.get(`${domain}/createdOrderItemsByOrderNumber/${id}`, {
      params: {
        pageNumber,
        pageSize,
      },
    });
    commit('SET_CREATED_ORDERS_BY_ORDER_NUMBER', []);
    commit('SET_ORDERITEMS_CURRENT_PAGE', []);
    commit('SET_TOTALITEMS_FOR_ORDERT', []);

    successCallback()
  },
  resetCreatedOrdersByOrderNumber({ commit }) {
    commit('SET_CREATED_ORDERS_BY_ORDER_NUMBER', [])
  },
  resetCreatedOrdersByOrderNumberMaterials({ commit }) {
    commit('SET_CREATED_ORDERS_BY_ORDER_NUMBER', [])
  },
  async locationi({ commit }, { locationId }) {
    const requestId = 'locationi'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain3}/location`, {
        params: {
          locationId,
        },
      });
      commit('SET_LOCATION', response.data);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async orderByOrderNumber({ commit }, { orderNumber }) {
    const requestId = 'orderByOrderNumber'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/orderByOrderNumber`, {
        params: {
          orderNumber,
        },
      });
      commit('SET_ORDER', response.data);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  // eslint-disable-next-line object-curly-newline
  async getOrdersOverview({ commit }, { year, salesType, pageNumber, pageSize, orderType, orderItemState, orderNumber, clientId, pickUpDate }) {
    const requestId = 'getOrdersOverview'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/orders_overview_pagination`, {
        params: {
          year,
          salesType,
          pageNumber,
          pageSize,
          orderNumber,
          clientId,
          pickUpDate,
          orderType,
          orderItemState,
        },
      });
      commit('SET_ORDERS', response.data.items);
      commit('SET_CURRENTPAGE', response.data.currentPage);
      commit('SET_TOTALITEMS_ORDERS', response.data.totalItems);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async loadPartiallyOrders({ commit }, {
    orderNumber, salesType, orderType, storeId, clientId, pageNumber, pageSize,
  }) {
    const requestId = 'loadPartiallyOrders'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/partially_delivered_orders`, {
        params: {
          orderNumber,
          salesType,
          orderType,
          storeId,
          clientId,
          pageNumber,
          pageSize,
        },
      });
      commit('SET_PARTIALLY_DELIVERED_ORDERS', response.data.items);
      commit('SET_TOTALITEMS_PARTIALLY_ORDERS', response.data.totalItems);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async getOrdersOverviewPDF({ commit }, {
    pageNumber, salesType, pageSize, orderType, orderItemState, orderNumber, clientId, pickUpDate, year,
  }) {
    const requestId = 'getOrdersOverviewPDF'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/orders_overview_pagination`, {
        params: {
          pageNumber,
          salesType,
          pageSize,
          orderNumber,
          clientId,
          pickUpDate,
          orderType,
          orderItemState,
          year,
        },
      });
      commit('SET_ORDERS_PDF', response.data);
      commit('SET_CURRENTPAGE', response.data.currentPage);
      commit('SET_TOTALITEMS_ORDERS', response.data.totalItems);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async adminOrdersOverview({ commit }, {
    orderState, orderType, orderNumber, clientId, pageNumber, pageSize,
  }) {
    const requestId = 'adminOrdersOverview'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/admin_OrdersOverviewPagination`, {
        params: {
          orderState,
          orderType,
          orderNumber,
          clientId,
          pageNumber,
          pageSize,

        },
      });
      commit('SET_ADMIN_ORDERS', response.data.items);
      commit('SET_CURRENTPAGE', response.data.currentPage);
      commit('SET_TOTALITEMS_ORDERS', response.data.totalItems);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async materialOrdersOverview({ commit }, {
    salesType, year, orderNumber, clientId, pageNumber, pageSize,
  }) {
    const requestId = 'materialOrdersOverview'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/editable_orders`, {
        params: {
          salesType,
          year,
          orderNumber,
          clientId,
          pageNumber,
          pageSize,
        },
      });
      commit('SET_MATERIAL_ORDERS', response.data.items);
      commit('SET_CURRENTPAGE', response.data.currentPage);
      commit('SET_TOTALITEMS_ORDERS', response.data.totalItems);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async resetmaterialOrdersOverview({ commit }) {
    commit('SET_MATERIAL_ORDERS', []);
    commit('SET_TOTALITEMS_ORDERS', 1);
  },
  async movingAllOrders({ commit }, {
    salesType, orderState, year, orderNumber, clientId, pageNumber, pageSize,
  }) {
    const requestId = 'movingAllOrders'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/all_orders`, {
        params: {
          salesType,
          orderState,
          year,
          orderNumber,
          clientId,
          pageNumber,
          pageSize,
        },
      });
      commit('SET_ALL_ORDER_MOVING', response.data.items);
      // commit('SET_CURRENTPAGE', response.data.currentPage);
      // commit('SET_TOTALITEMS_ORDERS', response.data.totalItems);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  resetInternalMoving({ commit }) {
    commit('SET_ALL_ORDER_MOVING', []);
  },
  resetOrdersOverview({ commit }) {
    commit('SET_ORDERS', []);
  },
  async materialVariantsByOrderNAndArticleN({ commit }, { orderNumber, windowItemId, teamNameId }) {
    const requestId = 'materialVariantsByOrderNAndArticleN'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/materialVariantsByOrderNumber`, {
        params: {
          windowItemId,
          orderNumber,
          teamNameId,
        },
      });
      commit('SET_MATERIAL_VARIANTS_OF_ORDER', response.data);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async get_edit_OrderItem({ commit }, orderItemId) {
    const requestId = 'get_edit_OrderItem'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/edit_OrderItem?orderItemId=${orderItemId}`);
      commit('SET_GET_EDIT_ORDER_ITEM', response.data);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
    // console.log('SET_GET_EDIT_ORDER_ITEM', response.data);
  },
  async edit_OrderItem_MaterialVariants({ commit }, orderItemId) {
    const requestId = 'edit_OrderItem_MaterialVariants'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/edit_OrderItem_MaterialVariants?orderItemId=${orderItemId}`);
      commit('SET_GET_EDIT_ORDER_ITEM_MATERIAL_VARIANT', response.data);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
    // console.log('SET_GET_EDIT_ORDER_ITEM', response.data);
  },
  resetMaterialVariantsByOrderNAndArticleN({ commit }) {
    commit('SET_MATERIAL_VARIANTS_OF_ORDER', []);
  },
  async readOrderItems({ commit }, { orderId, windowItemState }) {
    const requestId = 'readOrderItems'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/windowItems_overview_by_orderId`, {
        params: {
          orderId,
          windowItemState,
        },
      });
      commit('SET_ARTICLE_ORDERS', response.data);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async readOrderItemsMaterials({ commit }, { orderNumber, orderItemState }) {
    const requestId = 'readOrderItemsMaterials'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/material_orderItemsOverviewByOrderNumber`, {
        params: {
          orderNumber,
          orderItemState,
        },
      });
      commit('SET_ARTICLE_ORDERS_MATERIALS', response.data);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async resetReadOrderItems({ commit }) {
    commit('SET_ARTICLE_ORDERS', []);
  },
  async resetReadOrderItemsMaterials({ commit }) {
    commit('SET_ARTICLE_ORDERS_MATERIALS', []);
  },
  resetArticlesForOrder({ commit }) {
    commit('SET_ARTICLE_ORDERS', []);
  },
  async createOrderInStoreLocation({ commit }, { object, successCallback }) {
    const requestId = 'createOrderInStoreLocation'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.post(`${domain}/createOrderInStoreAndAssignLocation`, object);
      commit('SET_STATUS', true);
      Swal.fire({
        icon: 'success',
        title: 'Order created successfully',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2500,
      });

      // Call the success callback if provided
      if (successCallback && typeof successCallback === 'function') {
        successCallback();
      }
    } catch (error) {
      // Handle error response
      // Show error message using SweetAlert if needed
      if (error.response.status === 400) {
        Swal.fire({
          icon: 'error',
          title: 'Please provide a new Order Number',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
      } else if (error.response.status === 500) {
        Swal.fire({
          icon: 'error',
          title: error.response.data.Message,
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
        commit('SET_LOADING_STATE', { requestId, isLoading: false });
      }
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async createOrderByItems({ commit }, { object, successCallback }) {
    const requestId = 'createOrderByItems'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.post(`${domain}/create_order_items`, object);
      commit('SET_STATUS', true);
      Swal.fire({
        icon: 'success',
        title: 'Order created successfully',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2500,
      });

      // Call the success callback if provided
      if (successCallback && typeof successCallback === 'function') {
        successCallback();
      }
    } catch (error) {
      // Handle error response
      // Show error message using SweetAlert if needed
      if (error.response.status === 400) {
        Swal.fire({
          icon: 'error',
          title: 'Something wrong',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
      } else if (error.response.status === 500) {
        Swal.fire({
          icon: 'error',
          title: error.response.data.Message,
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
        commit('SET_LOADING_STATE', { requestId, isLoading: false });
      }
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async addOrderInNominative({ commit }, { object, successCallback }) {
    const requestId = 'addOrderInNominative'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.post(`${domain}/create_order_by_variants`, object);
      commit('SET_STATUS', true);
      Swal.fire({
        icon: 'success',
        title: 'Order created successfully',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2500,
      });

      // Call the success callback if provided
      if (successCallback && typeof successCallback === 'function') {
        successCallback();
      }
    } catch (error) {
      // Handle error response
      // Show error message using SweetAlert if needed
      if (error.response.status === 400) {
        Swal.fire({
          icon: 'error',
          title: 'Something wrong',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
      } else if (error.response.status === 500) {
        Swal.fire({
          icon: 'error',
          title: error.response.data.Message,
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
        commit('SET_LOADING_STATE', { requestId, isLoading: false });
      }
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async createOrder({ commit }, { object, successCallback }) {
    const requestId = 'createOrder'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.post(`${domain}/create_order`, object);
      commit('SET_STATUS', true);
      Swal.fire({
        icon: 'success',
        title: 'Created order',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2500,
      });
      successCallback(response.data);
    } catch (error) {
      // Handle error response
      // Show error message using SweetAlert if needed
      if (error.response.status === 400) {
        Swal.fire({
          icon: 'error',
          title: 'Invalid data. Please try again.',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
        commit('SET_LOADING_STATE', { requestId, isLoading: false });
      } else if (error.response.status === 500) {
        Swal.fire({
          icon: 'error',
          title: error.response.data.Message,
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
      }
      commit('SET_LOADING_STATE', { requestId, isLoading: false });
      throw error;
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async createOrderGenerally({ commit }, { object, successCallback }) {
    const requestId = 'createOrderGenerally'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.post(`${domain}/sale_mixed_products`, object);
      commit('SET_STATUS', true);
      Swal.fire({
        icon: 'success',
        title: 'Created order',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2500,
      });
      successCallback(response.data);
    } catch (error) {
      // Handle error response
      // Show error message using SweetAlert if needed
      if (error.response.status === 400) {
        Swal.fire({
          icon: 'error',
          title: 'Invalid data. Please try again.',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
        commit('SET_LOADING_STATE', { requestId, isLoading: false });
      } else if (error.response.status === 500) {
        Swal.fire({
          icon: 'error',
          title: error.response.data.Message,
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
      }
      commit('SET_LOADING_STATE', { requestId, isLoading: false });
      throw error;
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async addOrderInStore({ commit }, { object, successCallback }) {
    const requestId = 'addOrderInStore'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.post(`${domain}/createOrderInStore`, object);
      commit('SET_STATUS', true);
      Swal.fire({
        icon: 'success',
        title: 'Order in store created successfully',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2500,
      });

      // Call the success callback if provided
      if (successCallback && typeof successCallback === 'function') {
        successCallback();
      }
    } catch (error) {
      // Handle error response
      // Show error message using SweetAlert if needed
      if (error.response.status === 400) {
        Swal.fire({
          icon: 'error',
          title: error.response.data.Message,
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
      } else if (error.response.status === 500) {
        Swal.fire({
          icon: 'error',
          title: error.response.data.Message,
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
        commit('SET_LOADING_STATE', { requestId, isLoading: false });
      }
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async addLocationWithStore({ commit }, { object, successCallback }) {
    const requestId = 'addLocationWithStore'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.post(`${domain3}/add_location_to_store`, object);
      commit('SET_STATUS', true);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false });
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
    successCallback()
  },
  async addLocation({ commit }, { object, successCallback }) {
    // try {
    const requestId = 'addLocation'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.post(`${domain3}/add_location`, object);
      commit('SET_STATUS', true);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
    successCallback()

    //   Swal.fire({
    //     icon: 'success',
    //     title: 'Location added succesfully',
    //     toast: true,
    //     position: 'top-end',
    //     showConfirmButton: false,
    //     timer: 2500,
    //   });
    // } catch (error) {
    //   // Handle error response
    //   // Show error message using SweetAlert if needed
    //   if (error.response.status === 400) {
    //     Swal.fire({
    //       icon: 'error',
    //       title: 'Invalid location data. Please try again.',
    //       toast: true,
    //       position: 'top-end',
    //       showConfirmButton: false,
    //       timer: 2500,
    //     });
    //   } else if (error.response.status === 500) {
    //     Swal.fire({
    //       icon: 'error',
    //       title: error.response.data.Message,
    //       toast: true,
    //       position: 'top-end',
    //       showConfirmButton: false,
    //       timer: 2500,
    //     });
    //   }
    // }
  },
  async loadPriceForArticle({ commit }, { storeId, inventoryProductId }) {
    const requestId = 'loadPriceForArticle'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain3}/product_stock_details_by_inventoryProductId`, {
        params: {
          storeId,
          inventoryProductId,
        },
      });
      commit('SET_PRICE_FOR_ARTICLE', response.data);
      return response.data
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
      return 0
    }
  },
  async editWindowDetails({ commit }, { object, successCallback }) {
    const requestId = 'editWindowDetails'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.put(`${domain}/edit_window_details`, object);
      commit('SET_STATUS', true);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
    successCallback();
  },
  async addUsersToAppointment({ commit }, { object, appointmentId, successCallback }) {
    const requestId = 'addUsersToAppointment'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.post(`${domain}/add_employee_to_appointment?appointmentId=${appointmentId}`, object);
      commit('SET_STATUS', true);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
    successCallback();
  },
  async editAppointment({ commit }, { object, successCallback }) {
    const requestId = 'editAppointment'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.post(`${domain}/edit_appointment`, object);
      commit('SET_STATUS', true);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
    successCallback();
  },
  async assignWindowTo({ commit }, { object, successCallback }) {
    const requestId = 'assignWindowTo'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.put(`${domain}/assign_window_item_to`, object);
      commit('SET_STATUS', true);
      successCallback();
      Swal.fire({
        icon: 'success',
        title: 'Assigned team successfully',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2500,
      });
      return response.data
    } catch (error) {
      if (error.response.status === 400) {
        Swal.fire({
          icon: 'error',
          title: 'Invalid data. Please try again.',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
      } else if (error.response.status === 500) {
        Swal.fire({
          icon: 'error',
          title: error.response.data.Message,
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
      }
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
      throw error
    } finally {
      commit('SET_LOADING_STATE', { requestId, isLoading: false });
    }
  },
  async assignWindowsTo({ commit }, {
    object, successCallback,
  }) {
    const requestId = 'assignWindowsTo'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });

    try {
      const response = await axiosInstance.put(`${domain}/assign_window_items_to`, object);

      successCallback();
      Swal.fire({
        icon: 'success',
        title: 'Assigned team successfully',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2500,
      });

      commit('SET_STATUS', true);
      return response.data;
    } catch (error) {
      if (error.response?.status === 400) {
        Swal.fire({
          icon: 'error',
          title: 'Invalid data. Please try again.',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
      } else if (error.response?.status === 500) {
        Swal.fire({
          icon: 'error',
          title: error.response.data.Message,
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
      }

      commit('SET_LOADING_STATE', { requestId, isLoading: false });
      throw error;
    } finally {
      commit('SET_LOADING_STATE', { requestId, isLoading: false });
    }
  },
  // async createAppointment({ commit }, { object, successCallback }) {
  //   const requestId = 'createAppointment'
  //   commit('SET_LOADING_STATE', { requestId, isLoading: true });
  //   try {
  //     await axiosInstance.post(`${domain}/create_appointment`, object);
  //     commit('SET_STATUS', true);
  //     successCallback();
  //   } catch (error) {
  //     commit('SET_LOADING_STATE', { requestId, isLoading: false })
  //   }
  //   commit('SET_LOADING_STATE', { requestId, isLoading: false });
  // },
  async createAppointment({ commit }, { object, successCallback }) {
    const requestId = 'createAppointment'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.post(`${domain}/create_appointment`, object);
      commit('SET_STATUS', true);
      Swal.fire({
        icon: 'success',
        title: 'Created appointment',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2500,
      });
      successCallback(response.data);
    } catch (error) {
      // Handle error response
      // Show error message using SweetAlert if needed
      if (error.response.status === 400) {
        Swal.fire({
          icon: 'error',
          title: 'Invalid data. Please try again.',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
        commit('SET_LOADING_STATE', { requestId, isLoading: false });
      } else if (error.response.status === 500) {
        Swal.fire({
          icon: 'error',
          title: error.response.data.Message,
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
      }
      commit('SET_LOADING_STATE', { requestId, isLoading: false });
      throw error;
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async editLocation({ commit }, { object, successCallback }) {
    const requestId = 'editLocation'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.put(`${domain3}/edit_location_assigned_to_store`, object);
      commit('SET_STATUS', true);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
    successCallback();
  },
  async receiveProducts({ commit }, { object, successCallback }) {
    const requestId = 'receiveProducts'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.put(`${domain}/receive_productInStock_from_other_location`, object);
      commit('SET_STATUS', true);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
    successCallback();
  },
  async changeItemMovement({ commit }, { orderItemId, newState, successCallback }) {
    const requestId = 'changeItemMovement'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.put(`${domain3}change_line_item_movement_State?orderItemId=${orderItemId}&newState=${newState}`);
      commit('SET_STATUS', true);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
    successCallback();
  },
  async adjustDeliveryDate({ commit }, { object, successCallback }) {
    const requestId = 'adjustDeliveryDate'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.put(`${domain}/adjust_delivery_date`, object);
      commit('SET_STATUS', true);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
    successCallback();
  },
  async removeEmployee({ commit }, { object, successCallback }) {
    const requestId = 'removeEmployee'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.put(`${domain}/remove_employee_from_processing_track_and_trace`, object);
      commit('SET_STATUS', true);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
    successCallback();
  },
  async assignProcessinEmployee({ commit }, { object, successCallback }) {
    const requestId = 'assignProcessinEmployee'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.post(`${domain}/assign_employees_to_processing_track_and_trace`, object);
      commit('SET_STATUS', true);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
    successCallback();
  },
  async editTeamAdmin({ commit }, { object, successCallback }) {
    const requestId = 'editTeamAdmin'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.put(`${domain}/admin_assignedTeam`, object);
      commit('SET_STATUS', true);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
    successCallback();
  },
  async editStateAdmin({ commit }, { object, successCallback }) {
    const requestId = 'editStateAdmin'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.put(`${domain}/admin_changeOrderItemState`, object);
      commit('SET_STATUS', true);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
    successCallback();
  },
  async assignEmployeeToOrderItem({ commit }, { object, successCallback }) {
    const requestId = 'assignEmployeeToOrderItem'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.put(`${domain}/assigndEmployeeToOrderItem`, object);
      commit('SET_STATUS', true);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
    successCallback();
  },
  async assignEmployeeToProductInStock({ commit }, { object, successCallback }) {
    const requestId = 'assignEmployeeToProductInStock'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.put(`${domain}/assigndEmployeeToProductInStock`, object);
      commit('SET_STATUS', true);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
    successCallback();
  },
  async editVariantLength({ commit }, { orderItemId, object, successCallback }) {
    const requestId = 'editVariantLength'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.put(`${domain}/edit_VariantLengths_ByOrderItemId/${orderItemId}`, object);
      commit('SET_STATUS', true);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
    successCallback();
  },
  resetCustomOrders({ commit }) {
    commit('SET_RESET_STATUS', true);
  },
  resetCustomOrders2({ commit }) {
    commit('SET_RESET_STATUS', false);
  },
  resetMaterialVariantsOfOrders({ commit }) {
    commit('SET_MATERIAL_VARIANTS_OF_ORDER', []);
  },
  async updateOrderStatus({ commit }, { object, successCallback }) {
    const requestId = 'updateOrderStatus'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.put(`${domain}/change_window_item_state`, object);
      commit('SET_STATUS', true);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
    successCallback();
  },
  async updateMaterialStatus({ commit }, { object, successCallback }) {
    const requestId = 'updateMaterialStatus'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.put(`${domain}/material_changeOrderItemState`, object);
      commit('SET_STATUS', true);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
    successCallback();
  },
  async updateOrderStatusForce({ commit }, { object, successCallback }) {
    const requestId = 'updateOrderStatusForce'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.put(`${domain}/force_changeOrderItemState`, object);
      commit('SET_STATUS', true);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
    successCallback();
  },
  async edit_OrderItem({ commit }, { object, successCallback }) {
    // const updatedArray = object.map(({ editable, probeDate, ...rest }) => { return rest });
    // const requestData = JSON.stringify(updatedArray);
    const requestId = 'edit_OrderItem'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.put(`${domain}/edit_OrderItem`, object);
      commit('SET_STATUS', true);
      successCallback();
      Swal.fire({
        icon: 'success',
        title: 'Order item edited succesfully',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2500,
      });
    } catch (error) {
    // Handle error response
    // Show error message using SweetAlert if needed
      if (error.response.status === 400) {
        Swal.fire({
          icon: 'error',
          title: 'Invalid order item data. Please try again.',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
      } else if (error.response.status === 500) {
        Swal.fire({
          icon: 'error',
          title: error.response.data.Message,
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
        commit('SET_LOADING_STATE', { requestId, isLoading: false });
      }
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async editOrAddProbeDate({ commit }, { object, successCallback }) {
    const requestId = 'editOrAddProbeDate'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.put(`${domain}/edit_or_add_probeDate`, object);
      commit('SET_STATUS', true);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
    successCallback();
  },
  async editPaidAmount({ commit }, { object, successCallback }) {
    const requestId = 'editPaidAmount'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.put(`${domain}/edit_OrderItem_amounts?orderItemId=${object.orderItemId}&paidAmount=${object.paidAmount}`);
      commit('SET_STATUS', true);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
    successCallback();
  },
  async updateProductStatus({ commit }, { object, successCallback }) {
    const requestId = 'updateProductStatus'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.put(`${domain}/changeProductInStockState`, object);
      commit('SET_STATUS', true);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
    successCallback();
  },
  async updateRecycleStock({ commit }, { object, successCallback }) {
    const requestId = 'updateRecycleStock'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.put(`${domain}/change_product_to_recycle_or_inStock`, object);
      commit('SET_STATUS', true);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
    successCallback();
  },
  async updateToQualityNotPassed({ commit }, { object, successCallback }) {
    const requestId = 'updateToQualityNotPassed'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.put(`${domain}/qualityCheckNotPassed`, object);
      commit('SET_STATUS', true);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
    successCallback();
  },
  async searchByOrderNumber({ commit }, { orderNumber, salesType }) {
    const requestId = 'searchByOrderNumber'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/orderNumbersByOrderNumberLike`, {
        params: {
          orderNumber,
          salesType,
        },
      });
      commit('SET_FILTERED_ORDERS_BY_ON', response.data)
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async searchByDeliveryNumber({ commit }, { deliveryNumberLike }) {
    const requestId = 'searchByDeliveryNumber'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain5}/delivery_numbers_like`, {
        params: {
          deliveryNumberLike,
        },
      });
      commit('SET_DELIVER_NUMBER', response.data)
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async searchByInvoiceNumberFilter({ commit }, { invoiceNumberLike }) {
    const requestId = 'searchByInvoiceNumberFilter'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain5}/invoice_numbers_like`, {
        params: {
          invoiceNumberLike,
        },
      });
      commit('SET_INVOICE_NUMBER_FILTER', response.data)
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async loadOrderDescWidth({ commit }, { orderId, windowItemId }) {
    const requestId = 'loadOrderDescWidth'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/order_desc_windown_size`, {
        params: {
          orderId,
          windowItemId,
        },
      });
      commit('SET_GET_ORDER_DESC', response.data)
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async loadPaidAmountByOrderid({ commit }, { orderId }) {
    const requestId = 'loadPaidAmountByOrderid'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/paid_amount_by_orderId`, {
        params: {
          orderId,
        },
      });
      commit('SET_PAID_AMOUNT_BY_ORDERID', response.data)
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async loadArticlesInCart({ commit }, {
    storeId, inventoryProductId, orderState, pageNumber, pageSize,
  }) {
    const requestId = 'loadArticlesInCart'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain5}/cart_items`, {
        params: {
          storeId,
          inventoryProductId,
          orderState,
          pageNumber,
          pageSize,
        },
      });
      commit('SET_ARTICLES_IN_CART', response.data.items)
      commit('SET_ITEMS_ARTICLES_IN_CART', response.data.totalItems)
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async loadArticlesInCartOrdered({ commit }, {
    storeId, inventoryProductId, orderState, pageNumber, pageSize,
  }) {
    const requestId = 'loadArticlesInCartOrdered'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain5}/cart_items`, {
        params: {
          storeId,
          inventoryProductId,
          orderState,
          pageNumber,
          pageSize,
        },
      });
      commit('SET_ARTICLES_IN_CART_ORDERED', response.data.items)
      commit('SET_ITEMS_ARTICLES_IN_CART_ORDERED', response.data.totalItems)
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async loadArticlesInHistory({ commit }, {
    storeId, inventoryProductId, startDate, endDate, pageNumber, pageSize,
  }) {
    const requestId = 'loadArticlesInHistory'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain5}/cart_items_history`, {
        params: {
          storeId,
          inventoryProductId,
          startDate,
          endDate,
          pageNumber,
          pageSize,
        },
      })
      commit('SET_ARTICLES_IN_HISTORY', response.data.items)
      commit('SET_ITEMS_ARTICLES_IN_HISTORY', response.data.totalItems)
      commit('SET_TOTAL_PAGES_HISTORY', response.data.totalPages)
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async loadPDFArticlesInHistory({ commit }, {
    storeId, inventoryProductId, startDate, endDate, pageNumber, pageSize,
  }) {
    const requestId = 'loadPDFArticlesInHistory'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain5}/cart_items_history`, {
        params: {
          storeId,
          inventoryProductId,
          startDate,
          endDate,
          pageNumber,
          pageSize,
        },
      })
      commit('SET_PDF_ARTICLES_IN_HISTORY', response.data.items)
      commit('SET_PDF_ITEMS_ARTICLES_IN_HISTORY', response.data.totalItems)
      commit('SET_PDF_TOTAL_PAGES_HISTORY', response.data.totalPages)
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async loadClickedArticleInHistory({ commit }, {
    cartItemId,
  }) {
    const requestId = 'loadClickedArticleInHistory'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain5}/cart_item_tracking`, {
        params: {
          cartItemId,
        },
      })
      commit('SET_CLICKED_ARTICLE_IN_HISTORY', response.data)
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async isArticleOnCart({ commit }, {
    storeId, inventoryProductId,
  }) {
    const requestId = 'isArticleOnCart'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain5}/is_item_in_Cart`, {
        params: {
          storeId,
          inventoryProductId,
        },
      });
      commit('SET_IS_ARTICLE_IN_CART', response.data)
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
      return response.data
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
      return error
    }
  },
  resetDeliveryNumber({ commit }) {
    commit('SET_DELIVER_NUMBER', [])
  },
  resetInvoiceNumberLike({ commit }) {
    commit('SET_INVOICE_NUMBER_FILTER', [])
  },
  fshij({ commit }) {
    commit('SET_FILTERED_ORDERS_BY_ON', [])
  },
  resetOrdersNumbers({ commit }) {
    commit('SET_FILTERED_ORDERS_BY_ON', [])
  },
  async searchInNewOrders({ commit }, orderNumber) {
    const requestId = 'searchInNewOrders'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/createdOrderNumbersByOrderNumberLike?orderNumber=${orderNumber}`);
      commit('SET_SEARCH_NEW_ORDERS', response.data)
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  resetSearchInNewOrders({ commit }) {
    commit('SET_SEARCH_NEW_ORDERS', [])
  },
  async searchByCustomerName({ commit }, name) {
    const requestId = 'searchByCustomerName'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain2}/clientNamesByFirstNameLike/${name}`);
      commit('SET_FILTERED_ORDERS_BY_CN', response.data)
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  fshijCN({ commit }) {
    commit('SET_FILTERED_ORDERS_BY_CN', [])
  },
  resetClientName({ commit }) {
    commit('SET_FILTERED_ORDERS_BY_CN', [])
  },
  async loadOrderTypes({ commit }) {
    const requestId = 'loadOrderTypes'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    if (state.orderTypes.length > 0) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false });
      return;
    }
    try {
      const response = await axiosInstance.get(`${domain}/orderTypesInStore`);
      commit('SET_ORDER_TYPES', response.data);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async loadTwentyPrinciplesOrSize({ commit }, orderItemId) {
    const requestId = 'loadTwentyPrinciplesOrSize'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/bodyMeasurementsAndSize/${orderItemId}`);
      commit('SET_ORDER_ITEM_SIZE', response.data.size);
      commit('SET_TWENTY_PRINCIPLES', response.data.bodyMeasurements);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async loadDescriptionOfOrder({ commit }, orderNumber) {
    const requestId = 'loadDescriptionOfOrder'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/descriptionByOrderNumber/${orderNumber}`);
      commit('SET_DESCRIPTION', response.data);
      console.log('aa', response.data.items)
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async loadProbeDates({ commit }, orderItem) {
    const requestId = 'loadProbeDates'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/multiple_probeDates?orderItem=${orderItem}`);
      commit('SET_PROBEDATES', response.data);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async loadPrices({ commit }, orderItemId) {
    const requestId = 'loadPrices'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/orderItem_amounts?orderItemId=${orderItemId}`);
      commit('SET_PRICES', response.data);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async loadOrderItemLocation({ commit }, { orderItemId, articleNumber, clientId }) {
    const requestId = 'loadOrderItemLocation'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/orderItem_location`, {
        params: {
          orderItemId,
          articleNumber,
          clientId,
        },
      });
      commit('SET_ORDER_ITEM_LOCATIOON', response.data);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async resetLoadOrderItemLocation({ commit }) {
    commit('SET_ORDER_ITEM_LOCATIOON', []);
  },
  resetTwentyPrinciplesOrSize({ commit }) {
    commit('SET_ORDER_ITEM_SIZE', '');
    commit('SET_TWENTY_PRINCIPLES', null);
  },
  resetDescriptionOfOrder({ commit }) {
    commit('SET_DESCRIPTION', '');
  },
  async sell_productInStock({ commit }, {
    orderItemId, articleNumber, assignmentTeamNameId, successCallback,
  }) {
    const requestId = 'sell_productInStock'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.put(`${domain}/sell_productInStock?orderItemId=${orderItemId}&articleNumber=${articleNumber}&assignmentTeamNameId=${assignmentTeamNameId}`);
      commit('SET_STATUS', true);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
    successCallback()
  },
  async editCartArticleQuantity({ commit }, {
    object, successCallback,
  }) {
    const requestId = 'editCartArticleQuantity'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.put(`${domain5}/edit_cart_item_quantity`, object);
      commit('SET_STATUS', true);
      Swal.fire({
        icon: 'success',
        title: 'New quantity edited succesfully',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2500,
      });
      successCallback()
    } catch (error) {
    // Handle error response
    // Show error message using SweetAlert if needed
      if (error.response.status === 400) {
        Swal.fire({
          icon: 'error',
          title: 'Invalid data. Please try again.',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
      } else if (error.response.status === 500) {
        Swal.fire({
          icon: 'error',
          title: error.response.data.Message,
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
        commit('SET_LOADING_STATE', { requestId, isLoading: false });
      }
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async changeCartArticleState({ commit }, {
    object, cartItemId, newState, successCallback,
  }) {
    const requestId = 'changeCartArticleState'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.put(`${domain5}/change_cart_item_stet`, object, {
        params: {
          cartItemId,
          newState,
        },
      });
      commit('SET_STATUS', true);
      Swal.fire({
        icon: 'success',
        title: 'Ordered article.',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2500,
      });
      successCallback()
    } catch (error) {
    // Handle error response
    // Show error message using SweetAlert if needed
      if (error.response.status === 400) {
        Swal.fire({
          icon: 'error',
          title: 'Invalid data. Please try again.',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
      } else if (error.response.status === 500) {
        Swal.fire({
          icon: 'error',
          title: error.response.data.Message,
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
        commit('SET_LOADING_STATE', { requestId, isLoading: false });
      }
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async editOrders({ commit }, {
    obj, successCallback,
  }) {
    const requestId = 'editOrders'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.put(`${domain}/editOrder`, obj);
      commit('SET_STATUS', true);
      Swal.fire({
        icon: 'success',
        title: 'New orders edited succesfully',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2500,
      });
    } catch (error) {
    // Handle error response
    // Show error message using SweetAlert if needed
      if (error.response.status === 400) {
        Swal.fire({
          icon: 'error',
          title: 'Invalid order data. Please try again.',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
      } else if (error.response.status === 500) {
        Swal.fire({
          icon: 'error',
          title: error.response.data.Message,
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2500,
        });
        commit('SET_LOADING_STATE', { requestId, isLoading: false });
      }
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
    successCallback()
  },
  async delete_probeDate({ commit }, { probeId, successCallback }) {
    const requestId = 'delete_probeDate'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.delete(`${domain}/delete_probeDate?probeId=${probeId}`);
      commit('SET_STATUS', true);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
    successCallback();
  },
  // PassiveStock
  async addProductInStock({ commit }, object) {
    const requestId = 'addProductInStock'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.post(`${domain}/createProductInStock`, object);
      commit('SET_STATUS', true);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async addProductDirectInStock({ commit }, object) {
    const requestId = 'addProductDirectInStock'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.post(`${domain5}/add_products_in_stock`, object);
      commit('SET_STATUS', true);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async loadProductInStock({ commit }, {
    assignedTeamNameId, articleNumber, state, pageNumber, pageSize,
  }) {
    const requestId = 'loadProductInStock'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/productInStock_minimalPagination`, {
        params: {
          assignedTeamNameId,
          articleNumber,
          state,
          pageNumber,
          pageSize,
        },
      });
      commit('SET_PRODUCTS_IN_STOCK', response.data.items);
      commit('SET_CURRENTPAGE', response.data.currentPage);
      commit('SET_TOTALITEMS_ORDERS', response.data.totalItems);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
    // console.log('aa', response.data.items)
  },
  async loadProductInStockTrackAndTrace({ commit }, {
    productInStockId, pageNumber, pageSize,
  }) {
    const requestId = 'loadProductInStockTrackAndTrace'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/productInStock_trackAndTrace`, {
        params: {
          productInStockId,
          pageNumber,
          pageSize,
        },
      });
      commit('SET_PRODUCT_IN_STOCK_TRACK_TRACE', response.data.items);
      commit('SET_PRODUCT_IN_STOCK_TRACK_TRACE_CURRENT_PAGE', response.data.currentPage);
      commit('SET_PRODUCT_IN_STOCK_TRACK_TRACE_TOTAL_ITEMS', response.data.totalItems);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
    // console.log('aa', response.data.items)
  },
  async loadProductsStockQRCode({ commit }, articleNumber) {
    const requestId = 'loadProductsStockQRCode'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/productInStock_by_qr_code`, {
        params: {
          articleNumber,
        },
      });
      commit('SET_PRODUCTS_IN_STOCK_QRCODE', response.data);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
    // console.log('aa', response.data.items)
  },
  async loadProductInStockPDF({ commit }, {
    assignedTeamNameId, articleNumber, state, pageNumber, pageSize,
  }) {
    const requestId = 'loadProductInStockPDF'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/productInStock_minimalPagination`, {
        params: {
          assignedTeamNameId,
          articleNumber,
          state,
          pageNumber,
          pageSize,
        },
      });
      commit('SET_PRODUCTS_IN_STOCK_PDF', response.data);
      commit('SET_CURRENTPAGE', response.data.currentPage);
      commit('SET_TOTALITEMS_ORDERS', response.data.totalItems);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
    // console.log('aa', response.data.items)
  },
  async resetProductinStock({ commit }) {
    commit('SET_PRODUCTS_IN_STOCK', []);
  },
  async productInStock_cockpit_overview({ commit }, {
    assingedTeamNameId,
  }) {
    const requestId = 'productInStock_cockpit_overview'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/productInStock_cockpit_overview`, {
        params: {
          assingedTeamNameId,
        },
      });
      commit('SET_PRODUCT_IN_STOCK_DASHBOARD', response.data);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },

  async dashboard_Yearly_Graph({ commit }, {
    year,
  }) {
    const requestId = 'dashboard_Yearly_Graph'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/dashboard_Yearly_Graph`, {
        params: {
          year,
        },
      });
      commit('SET_YEARLY_DASHBOARD', response.data);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async dashboard_Monthly_Graph({ commit }, {
    state, month, year,
  }) {
    const requestId = 'dashboard_Monthly_Graph'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/dashboard_Monthly_Graph`, {
        params: {
          state,
          month,
          year,
        },
      });
      commit('SET_YEARLY_DASHBOARD', response.data);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },


  async assignProductInStockToTeam({ commit }, { object, successCallback }) {
    const requestId = 'assignProductInStockToTeam'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.put(`${domain}/assignProductInStockToTeam`, object);
      commit('SET_STATUS', true);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
    successCallback();
  },
  async productInStock_articleNumberLike({ commit }, articleNumberLike) {
    const requestId = 'productInStock_articleNumberLike'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain3}/article_numbers_like?articleNumberLike=${articleNumberLike}`);
      commit('E', response.data)
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async resetProductInStock({ commit }) {
    commit('E', [])
  },
  async upcomingPickupDays({ commit }, {
    numberOfDays, pageNumber, pageSize,
  }) {
    const requestId = 'upcomingPickupDays'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/upcomingPickupDays`, {
        params: {
          numberOfDays,
          pageNumber,
          pageSize,
        },
      });
      commit('SET_UP_COMING_PICKUP_DATES', response.data.items);
      commit('SET_CURRENTPAGE', response.data.currentPage);
      commit('SET_TOTALITEMS_ORDERS', response.data.totalItems);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
    // console.log('aa', response.data.items)
  },
  async productInStock_with_current_states({ commit }, {
    productInStockId, teamNameId,
  }) {
    const requestId = 'productInStock_with_current_states'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/productInStock_with_current_states`, {
        params: {
          productInStockId,
          teamNameId,
        },
      });
      commit('SET_PRODUCT_IN_STOCK_WITH_STATES', response.data);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
    // console.log('aa', response.data.items)
  },
  async productInStock_materialVariants({ commit }, {
    articleNumber,
  }) {
    const requestId = 'productInStock_materialVariants'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/productInStock_materialVariants`, {
        params: {
          articleNumber,
        },
      });
      commit('SET_PRODUCT_IN_STOCK_MATERIALVARIANTS', response.data);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
    // console.log('aa', response.data.items)
  },
  async most_Sold_Products({ commit }) {
    const requestId = 'most_Sold_Products'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/most_Sold_Products`);
      commit('SET_MOST_SOLD_PRODUCTS', response.data);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
    // console.log('aa', response.data.items)
  },
  async locations_by_type({ commit }, locationType) {
    const requestId = 'locations_by_type'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain3}/locations_by_type?locationType=${locationType}`);
      commit('SET_LOCATION_BY_TYPE', response.data);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
    // console.log('aa', response.data.items)
  },
  async orderItem_location_Pagination({ commit }, {
    orderItemId,
    articleNumber,
    clientId,
    pageNumber,
    pageSize,
  }) {
    const requestId = 'orderItem_location_Pagination'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/orderItem_location_Pagination`, {
        params: {
          orderItemId,
          articleNumber,
          clientId,
          pageNumber,
          pageSize,
        },
      });
      commit('SET_ORDER_ITEM_LOCATION', response.data.items);
      commit('SET_CURRENTPAGE', response.data.currentPage);
      commit('SET_TOTALITEMS_ORDERS', response.data.totalItems);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
    // console.log('aa', response.data.items)
  },
  async orderItemLocation_articleNumberLike({ commit }, articleNumber) {
    const requestId = 'orderItemLocation_articleNumberLike'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/orderItemLocation_articleNumberLike?articleNumber=${articleNumber}`);
      commit('SET_ARTICLE_NUMBER_LIKEE', response.data);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async productInStock_location_Pagination({ commit }, {
    orderItemId,
    articleNumber,
    locationId,
    pageNumber,
    pageSize,
  }) {
    const requestId = 'productInStock_location_Pagination'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/productInStock_location_Pagination`, {
        params: {
          orderItemId,
          articleNumber,
          locationId,
          pageNumber,
          pageSize,
        },
      });
      commit('SET_PRODUCT_IN_STOCK_LOCATION_PAGINATION', response.data.items);
      commit('SET_CURRENTPAGE', response.data.currentPage);
      commit('SET_TOTALITEMS_ORDERS', response.data.totalItems);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
    // console.log('aa', response.data.items)
  },
  async loadProductStockLocationPDF({ commit }, {
    orderItemId,
    articleNumber,
    locationId,
    pageNumber,
    pageSize,
  }) {
    const requestId = 'loadProductStockLocationPDF'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/productInStock_location_Pagination`, {
        params: {
          orderItemId,
          articleNumber,
          locationId,
          pageNumber,
          pageSize,
        },
      });
      commit('SET_PRODUCT_IN_STOCK_LOCATION_PDF', response.data);
      commit('SET_CURRENTPAGE', response.data.currentPage);
      commit('SET_TOTALITEMS_ORDERS', response.data.totalItems);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
    // console.log('aa', response.data.items)
  },
  async productInStockLocation_articleNumberLike({ commit }, articleNumber) {
    const requestId = 'productInStockLocation_articleNumberLike'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      const response = await axiosInstance.get(`${domain}/productInStockLocation_articleNumberLike?articleNumber=${articleNumber}`);
      commit('SET_PRODUCT_IN_STOCK_ARTICLE_NUMBER_LIKE', response.data);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
  },
  async change_orderItem_location({ commit }, { object, successCallback }) {
    const requestId = 'change_orderItem_location'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.put(`${domain}/change_orderItem_location`, object);
      commit('SET_STATUS', true);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
    successCallback();
  },
  async change_productInStock_locationn({ commit }, { object, successCallback }) {
    const requestId = 'change_productInStock_locationn'
    commit('SET_LOADING_STATE', { requestId, isLoading: true });
    try {
      await axiosInstance.put(`${domain}/change_productInStock_location`, object);
      commit('SET_STATUS', true);
    } catch (error) {
      commit('SET_LOADING_STATE', { requestId, isLoading: false })
    }
    commit('SET_LOADING_STATE', { requestId, isLoading: false });
    successCallback();
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
